import React, { useEffect, useState, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import * as env from 'config/environment';
import { isApp, isIosApp } from 'components/features/utils/userStatus';
import { HeadBlock } from './components/HeadBlock';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const $: any;

const InvestorBenefitsLP: React.FC = () => {
  const getURLWithParameter = (url: string): string => {
    return `${url}?service=${env.serviceName}&callback_url=${encodeURI(
      `${env.appURL}/auth`
    )}`;
  };
  const login = (): void => {
    window.location.href = getURLWithParameter(env.loginURL);
  };

  const register = (): void => {
    if (isUtmExist) {
      window.location.href = `${
        env.paymentProfilesURL
      }${params}&callback_url=${encodeURI(`${env.appURL}/auth`)}`;
    } else {
      window.location.href = `${
        env.paymentProfilesURL
      }?utm_source=tw_minkabu&utm_medium=lp_investorbenefit&utm_campaign=investor_benefit_202411&callback_url=${encodeURI(
        `${env.appURL}/auth`
      )}`;
    }
  };

  const location = useLocation();
  const params = location.search;
  const isUtmExist = params.includes('utm');

  const linkRegist = (): string => {
    if (isUtmExist) {
      return `${env.paymentProfilesURL}?${params}&callback_url=${encodeURI(
        `${env.appURL}/auth`
      )}`;
    } else {
      return `${
        env.paymentProfilesURL
      }?utm_source=tw_minkabu&utm_medium=lp_investorbenefit&utm_campaign=investor_benefit_202411&callback_url=${encodeURI(
        `${env.appURL}/auth`
      )}`;
    }
  };

  const [scrollWorries, setScrollWorries] = useState(true);
  const worriesScroll = useCallback(() => {
    let element = null;
    if (location.hash === '#worries1') {
      element = document.getElementById('worries1');
    } else if (location.hash === '#worries2') {
      element = document.getElementById('worries2');
    } else if (location.hash === '#worries3') {
      element = document.getElementById('worries3');
    } else if (location.hash === '#worries4') {
      element = document.getElementById('worries4');
    } else if (location.hash === '#sp-worries1') {
      element = document.getElementById('sp-worries1');
    } else if (location.hash === '#sp-worries2') {
      element = document.getElementById('sp-worries2');
    } else if (location.hash === '#sp-worries3') {
      element = document.getElementById('sp-worries3');
    } else if (location.hash === '#sp-worries4') {
      element = document.getElementById('worries4');
    }
    element?.scrollIntoView();
    setScrollWorries(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollWorries]);

  useEffect(() => {
    //toggle(表示・非表示の切り替え)
    //.js_toggle_switchのデータ属性(data-toggle="クラス名")と同じクラス名の要素の表示非表示の切り替えを行う
    //
    //sample
    //<button class="js_toggle_switch" data-toggle="js_rnavi">ボタン</button>
    //<div class="js_rnavi">表示切り替えエリア</div>
    //
    //クラス名がかぶらないよう、操作するクラスにつけるクラス名はルール化する
    //クラス名ルール例："js_"+"表示する内容を詳しく"
    $(function() {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      $('.js_toggle_switch').click(function(event: any) {
        const js_disp_area = '.' + $(event.currentTarget).data('toggle');
        $(js_disp_area).toggleClass('is-visible');
      });
    });

    //モーダルに画像入れる
    //const modalWrapper = document.querySelector('.ui-modal');
    const images = document.querySelectorAll('.image');
    const modalImage = document.querySelector('.modal-image');

    images.forEach(function(image) {
      image.addEventListener('click', function() {
        //modalWrapper.classList.add('show');
        //modalImage.classList.add('show');

        const imageSrc = image.getAttribute('data-src');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (modalImage as any).src = imageSrc;
      });
    });

    //modalWrapper.addEventListener('click', function() {
    //     if (this.classList.contains('show')) {
    //          this.classList.remove('show');
    //         modalImage.classList.remove('show');
    //     }
    //});

    //scroll
    const Ease = {
      easeInOut: (t: number) =>
        t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
    };
    const duration = 500;
    const smoothScrollTriggers = document.querySelectorAll('a[href^="#"]');
    smoothScrollTriggers.forEach(function(smoothScrollTrigger) {
      smoothScrollTrigger.addEventListener('click', function(e: Event) {
        const href = smoothScrollTrigger.getAttribute('href');
        const currentPostion =
          document.documentElement.scrollTop || document.body.scrollTop;
        const targetElement = document.getElementById(
          (href as string).replace('#', '')
        );
        if (targetElement) {
          e.preventDefault();
          e.stopPropagation();
          const targetPosition =
            window.pageYOffset +
            targetElement.getBoundingClientRect().top -
            115;
          const startTime = performance.now();
          const loop = function(nowTime: number) {
            const time = nowTime - startTime;
            const normalizedTime = time / duration;
            if (normalizedTime < 1) {
              window.scrollTo(
                0,
                currentPostion +
                  (targetPosition - currentPostion) *
                    Ease.easeInOut(normalizedTime)
              );
              requestAnimationFrame(loop);
            } else {
              window.scrollTo(0, targetPosition);
            }
          };
          requestAnimationFrame(loop);
        }
      });
    });

    //スクロールして画面内に入ってきたらfadeinアニメーションクラスを付与
    const myFunc = function() {
      //Classを追加する要素を取得
      const target = document.getElementsByClassName('js-ui-animation-fadeup');
      //Classを追加する位置を指定（ビューポート内）
      const position = Math.floor(window.innerHeight * 0.85); //左記はビューポート内の上から85%の位置を指定

      //要素の数だけループする
      for (let i = 0; i < target.length; i++) {
        //要素の上部座標を取得する（小数点切り捨て）
        const offsetTop = Math.floor(target[i].getBoundingClientRect().top); //要素の上部座標がpositionの位置を通過したら
        if (offsetTop < position) {
          //要素にClassを追加する
          target[i].classList.add('ui-animation-fadeup');
        }
      }
    };
    //スクロールイベントリスナーに登録
    window.addEventListener('scroll', myFunc, false);

    return () => {
      window.removeEventListener('scroll', myFunc, false);
    };
  }, []);

  const isIE =
    (window.navigator.userAgent ?? '').toLowerCase().indexOf('trident') !== -1;

  const headBlockValue = {
    secondScript: `{
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "みんかぶアセットプランナー（アセプラ）とは何ですか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "みんかぶアセットプランナーとは、株式や投資信託を管理、分析する投資管理アプリです。複数の証券口座にある株式や投資信託の損益、資産推移をまとめて管理できます。"
        }
      },
      {
        "@type": "Question",
        "name": "みんかぶアセットプランナー（アセプラ）でどんなことができますか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "複数の証券口座をまとめて管理し、国内株、米国株、投資信託、NISAなどの取引を分析することができます。複数の投資口座の損益や資産総額を日ごと、週ごと、月ごとにレポートで確認できるため、証券口座ごとに資産変動がすぐにわかります。"
        }
      },
      {
        "@type": "Question",
        "name": "連携できる証券会社はどこですか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "SBI証券、楽天証券をご連携いただけます。その他の証券会社は連携準備中となります（2025年8月時点）。<br>連携準備中の証券会社はMoneytreeと連携することで一部の資産を管理できます。"
        }
      },
      {
        "@type": "Question",
        "name": "連携できる金融商品はなんですか？",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "国内株式（現物、信用）、外国株式（現物）、投資信託、ETF・ETN（国内、外国）、REIT（国内、外国）、債券（国内、外国）、EB（国内、外国）、ロボアドバイザー、現金を連携できます。不動産、ゴールドなどは、手入力で管理できます。"
        }
      },
      {
          "@type": "Question",
          "name": "銀行口座も連携できますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "みんかぶアセットプランナーでは家計簿アプリ「マネーツリー」と連携し、銀行口座の「残高」や「取引/入出金履歴」を管理することができます。※ Moneytree IDと連携する必要があります。"
          }
        },
        {
          "@type": "Question",
          "name": "おすすめの国内株式を提案する機能はありますか？",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "みんかぶアセットプランナーには国内株式を提案する機能はありません。みんかぶの「株式ランキング」や「銘柄スクリーニング」などで銘柄を探すことができます。"
          }
        },
      {
        "@type": "Question",
        "name": "みんかぶアセットプランナーの利用料金を教えてください",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "全ての機能を利用するには「みんかぶプレミアム（税込1,320円/月）」にご登録が必要です。<br>初回登録のみ30日間無料でご利用いただけます。"
        }
      }
    ]
  }`,
  };

  /* eslint-disable react/jsx-no-target-blank */
  return (
    <>
      <HeadBlock
        {...{ noindex: true, secondScript: headBlockValue.secondScript }}
      />
      <div className="login relative" id="layout">
        <div className="bg-gradient-b-bluegray">
          <div className="lg:flex container h-96 lg:px-4 lg:px-0  relative">
            <div className="lg:w-2/3 overflow-hidden relative">
              <img
                src="/static/images/lp/assetplanner_lp.png"
                alt="アセプラの画面イメージ"
                width="1560"
                height="1000"
                className="lg:absolute bottom-0 block ui-animation-slidein"
              />
              <img
                src="/static/images/lp/assetplanner_lp_parts3.png"
                alt="アセプラ機能3"
                style={{ top: '58%', left: '29%' }}
                className="w-lpImageSp lg:w-lpImagePc3 absolute ui-animation-popup-delay3"
              />
              <img
                src="/static/images/lp/assetplanner_lp_parts1.png"
                alt="アセプラ機能1"
                style={{ top: '39%', left: '47%' }}
                className="w-lpImageSp lg:w-lpImagePc2 absolute ui-animation-popup-delay2"
              />
              <img
                src="/static/images/lp/assetplanner_lp_parts2.png"
                alt="アセプラ機能2"
                style={{ top: '9%', left: '34%' }}
                className="w-lpImageSp lg:w-lpImagePc1 absolute ui-animation-popup-delay1"
              />
              <div
                className="bg-red-600 absolute font-bold text-white lg:text-2xl text-xl py-1 px-4"
                style={{ top: '70%', left: '0%' }}>
                口座ごとの運用状況、まとめて見える
              </div>
            </div>
            <div className=" lg:w-1/3 lg:pt-8 z-10">
              <div className="text-white lg:rounded-lg lg:bg-none p-4 lg:bg-none lg:rounded-lg text-center">
                <h1 className="font-bold text-lg  py-2 text-center" id="top">
                  <span className="text-sm lg:text-sm block">
                    資産形成のための投資管理ツール
                  </span>
                  <img
                    loading="lazy"
                    src="/static/images/lp/logo_minkabu_as_dark.svg"
                    alt="アセプラ（みんかぶアセットプランナー）ロゴ"
                    title="アセプラ（みんかぶアセットプランナー）ロゴ"
                    width="300"
                    height="82"
                    className="mx-auto py-2 w-2/3 lg:w-4/5"
                  />
                </h1>
                <div className="text-lg lg:block flex space-x-2 lg:space-x-0">
                  {isIE && (
                    <button className="w-full ui-button theme-sub mb-2 whitespace-no-wrap">
                      IEブラウザでは
                      <br />
                      ご利用いただけません
                    </button>
                  )}
                </div>
                {/* PCのみ */}
                {!isApp && (
                  <div className="hidden lg:block py-2 px-4 lg:mt-4 mb-2 bg-gray-500 text-white rounded-full text-center bg-opacity-75 font-bold text-sm">
                    初回登録30日間、無料キャンペーン中！
                  </div>
                )}
                <div className="text-lg block space-x-0">
                  {!isIE && (
                    <>
                      <button
                        className="w-full ui-button bg-gradient-r-orange mb-2 whitespace-no-wrap register-exe cv_premium"
                        id="click_login_register"
                        onClick={register}>
                        <div className="rounded-full px-2 bg-white text-orange text-xs w-32 m-auto">
                          初めてご利用の方
                        </div>
                        新規登録
                      </button>
                      <button
                        className="w-full ui-button mb-2 whitespace-no-wrap login-exe"
                        id="click_login_login"
                        onClick={login}>
                        <div className="rounded-full px-3 bg-white text-blue text-xs w-56 m-auto">
                          すでにみんかぶプレミアム会員の方
                        </div>
                        ログイン
                      </button>
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {!isApp && (
          <>
            {/* お悩み別4つの資産管理方法 */}
            <section className="container">
              {/* PC */}
              <div className="hidden lg:flex flex-col mt-16 mb-30">
                <div className="text-center mb-20">
                  <h2 id="assets_management" className="text-xl font-bold mb-2">
                    投資家向けお金の管理ツール
                    <br />
                    <span className="text-2xl">資産運用の「困った」を解決</span>
                  </h2>
                  <div
                    className="h-4 bg-red-500 right-half mx-auto mt-2"
                    style={{ width: '21rem' }}></div>
                </div>
                <div
                  className="flex flex-row justify-center px-20"
                  style={{ height: '370px' }}>
                  <div
                    className="flex flex-col mx-4 p-4 bg-white border border-bluegray-300 rounded-lg"
                    style={{ width: '350px' }}>
                    <div className="relative -top-19 -left-4 z-10">
                      <div className="absolute px-2 text-sm font-bold text-white bg-yellow-450 rounded-lg">
                        お悩み<span className="text-lg">1</span>
                      </div>
                    </div>
                    <div className="relative -top-6">
                      <h3 className="flex items-center mb-6 absolute bubble-border-block w-full max-w-bubble bubble-border-block">
                        <img
                          src="/static/images/lp/onayami-hukidashi1.svg"
                          alt="株式の資産推移を見える化したい"
                          className="w-full"
                        />
                      </h3>
                    </div>
                    <img
                      src="/static/images/lp/onayami1.svg"
                      alt="資産管理や推移をグラフで確認したい"
                      className="w-full"
                    />
                    <div className="flex flex-row mt-2">
                      <div className="px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        株式の損益管理
                      </div>
                      <div className="ml-1 px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        ポートフォリオの管理
                      </div>
                    </div>
                    <div className="mt-2 flex-grow">
                      <div className="flex flex-row items-baseline text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          複数の証券口座にある株式や投資信託の損益、資産の推移をまとめて見たい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          証券口座ごとに株式のポートフォリオを管理したい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          複数口座の資産の合計額や確定損益を管理したい
                        </div>
                      </div>
                    </div>
                    <a href="#worries1">
                      <div className="flex flex-row items-center justify-center py-2 text-lg font-bold text-center border border-cyan-450 text-cyan-450 rounded-lg">
                        <div>解決方法は？</div>
                        <img
                          src="/static/images/lp/icon_finger.svg"
                          alt=""
                          width="18"
                          height="18"
                          className="ml-2"
                          style={{ transform: 'rotate(315deg)' }}
                        />
                      </div>
                    </a>
                  </div>
                  <div
                    className="flex flex-col mx-4 p-4 bg-white border border-bluegray-300 rounded-lg"
                    style={{ width: '350px' }}>
                    <div className="relative -top-19 -left-4 z-10">
                      <div className="absolute px-2 text-sm font-bold text-white bg-yellow-450 rounded-lg">
                        お悩み<span className="text-lg">2</span>
                      </div>
                    </div>
                    <div className="relative -top-6">
                      <h3 className="flex items-center mb-6 absolute bubble-border-block w-full max-w-bubble bubble-border-block">
                        <img
                          src="/static/images/lp/onayami-hukidashi2.svg"
                          alt="複数の証券口座を1ヶ所で管理したい"
                          className="w-full"
                        />
                      </h3>
                    </div>
                    <img
                      src="/static/images/lp/onayami2.svg"
                      alt="複数の証券口座を管理したい"
                      className="w-full"
                    />
                    <div className="flex flex-row mt-2">
                      <div className="px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        保有株の管理
                      </div>
                      <div className="ml-1 px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        資産の一括管理
                      </div>
                    </div>
                    <div className="mt-2 flex-grow">
                      <div className="flex flex-row items-baseline text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          複数の証券口座にある株式や投資信託を、『口座ごと』、老後資金など『目的ごと』に一括で管理したい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          複数の投資口座をまとめて管理したい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          iDeCo口座、NISA口座の残高や運用を確認したい
                        </div>
                      </div>
                    </div>
                    <a href="#worries2">
                      <div className="flex flex-row items-center justify-center py-2 text-lg font-bold text-center border border-cyan-450 text-cyan-450 rounded-lg">
                        <div>解決方法は？</div>
                        <img
                          src="/static/images/lp/icon_finger.svg"
                          alt=""
                          width="18"
                          height="18"
                          className="ml-2"
                          style={{ transform: 'rotate(315deg)' }}
                        />
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className="flex flex-row justify-center px-20 mt-24"
                  style={{ height: '370px' }}>
                  <div
                    className="flex flex-col mx-4 p-4 bg-white border border-bluegray-300 rounded-lg"
                    style={{ width: '350px' }}>
                    <div className="relative -top-19 -left-4 z-10">
                      <div className="absolute px-2 text-sm font-bold text-white bg-yellow-450 rounded-lg">
                        お悩み<span className="text-lg">3</span>
                      </div>
                    </div>
                    <div className="relative -top-6">
                      <h3 className="flex items-center mb-6 absolute bubble-border-block w-full max-w-bubble bubble-border-block">
                        <img
                          src="/static/images/lp/onayami-hukidashi3.svg"
                          alt="自分の取引の傾向を知りたい"
                          className="w-full"
                        />
                      </h3>
                    </div>
                    <img
                      src="/static/images/lp/onayami3.svg"
                      alt="株の取引履歴などを確認したい"
                      className="w-full"
                    />
                    <div className="flex flex-row mt-2">
                      <div className="px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        取引履歴の分析
                      </div>
                      <div className="ml-1 px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        チャート分析
                      </div>
                    </div>
                    <div className="mt-2 flex-grow">
                      <div className="flex flex-row items-baseline text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          国内株、米国株、投資信託、NISAの取引履歴を株価チャートに残して分析したい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          過去の取引タイミングから、投資の傾向をつかみ、今後の売買に役立てたい
                        </div>
                      </div>
                    </div>
                    <a href="#worries3">
                      <div className="flex flex-row items-center justify-center py-2 text-lg font-bold text-center border border-cyan-450 text-cyan-450 rounded-lg">
                        <div>解決方法は？</div>
                        <img
                          src="/static/images/lp/icon_finger.svg"
                          alt=""
                          width="18"
                          height="18"
                          className="ml-2"
                          style={{ transform: 'rotate(315deg)' }}
                        />
                      </div>
                    </a>
                  </div>
                  <div
                    className="flex flex-col mx-4 p-4 bg-white border border-bluegray-300 rounded-lg"
                    style={{ width: '350px' }}>
                    <div className="relative -top-19 -left-4 z-10">
                      <div className="absolute px-2 text-sm font-bold text-white bg-yellow-450 rounded-lg">
                        お悩み<span className="text-lg">4</span>
                      </div>
                    </div>
                    <div className="relative -top-6">
                      <h3 className="flex items-center mb-6 absolute bubble-border-block w-full max-w-bubble bubble-border-block">
                        <img
                          src="/static/images/lp/onayami-hukidashi4.svg"
                          alt="複数口座の損益をまとめて知りたい"
                          className="w-full"
                        />
                      </h3>
                    </div>
                    <img
                      src="/static/images/lp/onayami4.svg"
                      alt="資産変動のお知らせが欲しい"
                      className="w-full"
                    />
                    <div className="flex flex-row mt-2">
                      <div className="px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        投資の収支管理
                      </div>
                      <div className="ml-1 px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        LINE通知
                      </div>
                    </div>
                    <div className="mt-2 flex-grow">
                      <div className="flex flex-row items-baseline text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          日ごと、週ごと、月ごとに資産変動や株式、投資信託の損益を知りたい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          LINEで最新の資産を確認し、売買タイミングを逃さないようにしたい
                        </div>
                      </div>
                    </div>
                    <a href="#worries4">
                      <div className="flex flex-row items-center justify-center py-2 text-lg font-bold text-center border border-cyan-450 text-cyan-450 rounded-lg">
                        <div>解決方法は？</div>
                        <img
                          src="/static/images/lp/icon_finger.svg"
                          alt=""
                          width="18"
                          height="18"
                          className="ml-2"
                          style={{ transform: 'rotate(315deg)' }}
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div className="flex lg:hidden flex-col bg-white pt-12 pb-12">
                <div className="text-center">
                  <h2
                    id="assets_management_sp"
                    className="text-xl font-bold mb-2">
                    投資家のためのお金の管理ツール
                    <br />
                    <span className="text-2xl">資産運用の「困った」を解決</span>
                  </h2>
                  <div
                    className="h-4 bg-red-500 right-half mx-auto"
                    style={{ width: '20rem' }}></div>
                </div>
                <div className="flex flex-col px-1">
                  <div
                    className="flex flex-col w-full h-full min-h-92 p-4 bg-white border border-bluegray-300 rounded-lg"
                    style={{ marginTop: '23%' }}>
                    <div className="relative -top-19 -left-4 z-10">
                      <div className="absolute px-2 text-sm font-bold text-white bg-yellow-450 rounded-lg">
                        お悩み<span className="text-lg">1</span>
                      </div>
                    </div>
                    <div className="relative -top-6">
                      <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                        <img
                          src="/static/images/lp/onayami-hukidashi1.svg"
                          alt="株式の資産推移を見える化したい"
                          className="w-full"
                        />
                      </h3>
                    </div>
                    <img
                      src="/static/images/lp/onayami1.svg"
                      alt="資産管理や推移をグラフで確認したい"
                      className="w-full"
                    />
                    <div className="flex flex-row mt-2">
                      <div className="px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        株式の損益管理
                      </div>
                      <div className="ml-1 px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        ポートフォリオの管理
                      </div>
                    </div>
                    <div className="mt-2 flex-grow">
                      <div className="flex flex-row items-baseline text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          複数の証券口座にある株式や投資信託の損益、資産の推移をまとめて見たい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          証券口座ごとに株式のポートフォリオを管理したい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          複数口座の資産の合計額や確定損益を管理したい
                        </div>
                      </div>
                    </div>
                    <a href="#sp-worries1">
                      <div className="flex flex-row items-center justify-center py-2 mt-2 text-lg font-bold text-center border border-cyan-450 text-cyan-450 rounded-lg">
                        <div>解決方法は？</div>
                        <img
                          src="/static/images/lp/icon_finger.svg"
                          alt=""
                          width="18"
                          height="18"
                          className="ml-2"
                          style={{ transform: 'rotate(315deg)' }}
                        />
                      </div>
                    </a>
                  </div>
                  <div
                    className="flex flex-col w-full h-full min-h-92 p-4 bg-white border border-bluegray-300 rounded-lg"
                    style={{ marginTop: '22%' }}>
                    <div className="relative -top-19 -left-4 z-10">
                      <div className="absolute px-2 text-sm font-bold text-white bg-yellow-450 rounded-lg">
                        お悩み<span className="text-lg">2</span>
                      </div>
                    </div>
                    <div className="relative -top-6">
                      <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                        <img
                          src="/static/images/lp/onayami-hukidashi2.svg"
                          alt="複数の証券口座を1ヶ所で管理したい"
                          className="w-full"
                        />
                      </h3>
                    </div>
                    <img
                      src="/static/images/lp/onayami2.svg"
                      alt="複数の証券口座を管理したい"
                      className="w-full"
                    />
                    <div className="flex flex-row mt-2">
                      <div className="px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        保有株の管理
                      </div>
                      <div className="ml-1 px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        資産の一括管理
                      </div>
                    </div>
                    <div className="mt-2 flex-grow">
                      <div className="flex flex-row items-baseline text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          複数の証券口座にある株式や投資信託を、『口座ごと』、老後資金など『目的ごと』に一括で管理したい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          複数の投資口座をまとめて管理したい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          iDeCo口座、NISA口座の残高や運用を確認したい
                        </div>
                      </div>
                    </div>
                    <a href="#sp-worries2">
                      <div className="flex flex-row items-center justify-center py-2 mt-2 text-lg font-bold text-center border border-cyan-450 text-cyan-450 rounded-lg">
                        <div>解決方法は？</div>
                        <img
                          src="/static/images/lp/icon_finger.svg"
                          alt=""
                          width="18"
                          height="18"
                          className="ml-2"
                          style={{ transform: 'rotate(315deg)' }}
                        />
                      </div>
                    </a>
                  </div>
                  <div
                    className="flex flex-col w-full h-full min-h-92 p-4 bg-white border border-bluegray-300 rounded-lg"
                    style={{ marginTop: '22%' }}>
                    <div className="relative -top-19 -left-4 z-10">
                      <div className="absolute px-2 text-sm font-bold text-white bg-yellow-450 rounded-lg">
                        お悩み<span className="text-lg">3</span>
                      </div>
                    </div>
                    <div className="relative -top-6">
                      <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                        <img
                          src="/static/images/lp/onayami-hukidashi3.svg"
                          alt="自分の取引の傾向を知りたい"
                          className="w-full"
                        />
                      </h3>
                    </div>
                    <img
                      src="/static/images/lp/onayami3.svg"
                      alt="株の取引履歴などを確認したい"
                      className="w-full"
                    />
                    <div className="flex flex-row mt-2">
                      <div className="px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        取引履歴の分析
                      </div>
                      <div className="ml-1 px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        チャート分析
                      </div>
                    </div>
                    <div className="mt-2 flex-grow">
                      <div className="flex flex-row items-baseline text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          国内株、米国株、投資信託、NISAの取引履歴を株価チャートに残して分析したい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          過去の取引タイミングから、投資の傾向をつかみ、今後の売買に役立てたい
                        </div>
                      </div>
                    </div>
                    <a href="#sp-worries3">
                      <div className="flex flex-row items-center justify-center py-2 mt-2 text-lg font-bold text-center border border-cyan-450 text-cyan-450 rounded-lg">
                        <div>解決方法は？</div>
                        <img
                          src="/static/images/lp/icon_finger.svg"
                          alt=""
                          width="18"
                          height="18"
                          className="ml-2"
                          style={{ transform: 'rotate(315deg)' }}
                        />
                      </div>
                    </a>
                  </div>
                  <div
                    className="flex flex-col w-full h-full min-h-92 p-4 bg-white border border-bluegray-300 rounded-lg"
                    style={{ marginTop: '22%' }}>
                    <div className="relative -top-19 -left-4 z-10">
                      <div className="absolute px-2 text-sm font-bold text-white bg-yellow-450 rounded-lg">
                        お悩み<span className="text-lg">4</span>
                      </div>
                    </div>
                    <div className="relative -top-6">
                      <h3 className="flex items-center mb-6 absolute bubble-border-block w-full lg:max-w-bubble lg:bubble-border-block">
                        <img
                          src="/static/images/lp/onayami-hukidashi4.svg"
                          alt="資産変動をまとめて教えてほしい"
                          className="w-full"
                        />
                      </h3>
                    </div>
                    <img
                      src="/static/images/lp/onayami4.svg"
                      alt="資産変動のお知らせが欲しい"
                      className="w-full"
                    />
                    <div className="flex flex-row mt-2">
                      <div className="px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        投資の収支管理
                      </div>
                      <div className="ml-1 px-2 py-1 text-xs font-bold text-white bg-bluegray-500 rounded">
                        LINE通知
                      </div>
                    </div>
                    <div className="mt-2 flex-grow">
                      <div className="flex flex-row items-baseline text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          日ごと、週ごと、月ごとに資産変動や株式、投資信託の損益を知りたい
                        </div>
                      </div>
                      <div className="flex flex-row items-baseline mt-1 text-sm">
                        <div className="icon-check text-cyan-600 font-bold"></div>
                        <div className="ml-1">
                          LINEで最新の資産を確認し、売買タイミングを逃さないようにしたい
                        </div>
                      </div>
                    </div>
                    <a href="#sp-worries4">
                      <div className="flex flex-row items-center justify-center py-2 mt-2 text-lg font-bold text-center border border-cyan-450 text-cyan-450 rounded-lg">
                        <div>解決方法は？</div>
                        <img
                          src="/static/images/lp/icon_finger.svg"
                          alt=""
                          width="18"
                          height="18"
                          className="ml-2"
                          style={{ transform: 'rotate(315deg)' }}
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* 「どの口座が増えてる？」自分の資産がいくらかわからない */}
            <section className="bg-cyan-600 text-white js-ui-animation-fadeup">
              {/* PC */}
              <div className="hidden lg:flex flex-col container w-full overflow-hidden">
                <h2 className="pt-16 text-2xl font-bold text-center">
                  「どの口座が増えてる？」自分の資産がいくらかわからない
                </h2>

                <div className="relative mb-8">
                  <img
                    src="/static/images/lp/assetsUnknownPop.svg"
                    alt="資産がわからないを卒業"
                    width="214"
                    height="30"
                    className="absolute pt-8"
                  />
                </div>

                <div className="flex flex-row pt-4 pb-16">
                  <div className="flex flex-col justify-center w-1/2 pr-8 ml-24">
                    <h3 className="text-xl font-bold mt-8 mr-auto">
                      複数口座の資産をまとめて管理！
                    </h3>
                    <div className="mt-2 text-base leading-8">
                      <span className="flex flex-row">
                        <img
                          src="/static/images/lp/circle-check.svg"
                          alt="チェックサークル"
                        />
                        「複数アプリの使いわけが大変」を解決
                      </span>
                      <span className="flex flex-row">
                        <img
                          src="/static/images/lp/circle-check.svg"
                          alt="チェックサークル"
                        />
                        複数の証券口座の損益がわかる
                      </span>
                      <span className="flex flex-row">
                        <img
                          src="/static/images/lp/circle-check.svg"
                          alt="チェックサークル"
                        />
                        資産の変動にすぐ気づける
                      </span>
                    </div>
                    <div className="mt-8 text-base leading-8">
                      「どの口座が増えた？減った？」複数の証券口座を使い分けていると、それぞれのアプリで確認するのが大変ですよね。
                      <br />
                      「損益をまとめたい」「資産の合計をすぐに知りたい」など複数口座を管理する方にお悩み別の解決方法を紹介します。
                    </div>
                  </div>
                  <div className="w-1/2 pl-8">
                    <img
                      src="/static/images/lp/recommend.svg"
                      alt="資産管理方法のおすすめ紹介"
                      className="w-full"
                    />
                  </div>
                </div>
              </div>
              {/* SP */}
              <div className="lg:hidden flex flex-col py-12">
                <h2 className="pb-8 text-2xl font-bold text-center">
                  「どの口座が増えてる？」
                  <br />
                  自分の資産がいくらか
                  <br />
                  わからない
                </h2>
                <div className="px-10">
                  <div className="w-full">
                    <img
                      src="/static/images/lp/recommend.svg"
                      alt="資産管理方法のおすすめ紹介"
                      className="w-full"
                    />
                  </div>
                </div>
                <div className="px-6">
                  <div className="flex flex-col justify-center w-full">
                    <img
                      src="/static/images/lp/assetsUnknownPop.svg"
                      alt="資産がわからないを卒業"
                      width="175"
                      height="55"
                      className="mt-4"
                    />
                    <h3 className="mt-2 mb-4 mx-auto text-xl font-bold">
                      複数口座の資産をまとめて管理！
                    </h3>
                    <div className="mt-1 text-base leading-8">
                      <span className="inline-block">
                        <img
                          src="/static/images/lp/circle-check.svg"
                          alt="チェックサークル"
                          className="mr-2"
                        />
                      </span>
                      「複数アプリの使いわけが大変」を解決
                      <br />
                      <span className="inline-block">
                        <img
                          src="/static/images/lp/circle-check.svg"
                          alt="チェックサークル"
                          className="mr-2"
                        />
                      </span>
                      複数の証券口座の損益がわかる
                      <br />
                      <span className="inline-block">
                        <img
                          src="/static/images/lp/circle-check.svg"
                          alt="チェックサークル"
                          className="mr-2"
                        />
                      </span>
                      資産の変動にすぐ気づける
                    </div>
                    <br />
                    <div className="mt-1 text-base leading-8">
                      「どの口座が増えた？減った？」複数の証券口座を使い分けていると、それぞれのアプリで確認するのが大変ですよね。
                      <br />
                      「損益をまとめたい」「資産の合計をすぐに知りたい」など
                      <br />
                      複数口座を管理する方にお悩み別の解決方法を紹介します。
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* 株式の資産推移を見える化したい */}
            <section className="text-white bg-gray-800">
              {/* PC */}
              <div
                className="hidden lg:flex container w-full pt-16 mb-12"
                id="worries1"
                ref={worriesScroll}>
                <div className="w-1/3 flex justify-center h-116 overflow-hidden relative">
                  <img
                    src="/static/images/lp/worries1.png"
                    alt="資産管理をチャートが見やすくわかりやすい"
                    width="340"
                    height="550"
                    className="image top-0 absolute object-cover"
                  />
                </div>
                <div className="w-2/3 pl-10">
                  <div className="flex flex-row items-center">
                    <div className="px-2 text-sm font-bold bg-yellow-450 rounded-lg">
                      お悩み<span className="text-lg">1</span>
                    </div>
                    <div className="font-bold pl-2">
                      株式の<span className="text-23">資産推移</span>
                      を見える化したい
                    </div>
                  </div>
                  <div className="mt-3 text-3xl font-bold">
                    <h2>
                      【解決方法】すべての資産を
                      <div className="pr-10 text-right">
                        チャート・グラフで管理
                      </div>
                    </h2>
                  </div>
                  <div className="flex flex-row mt-2 text-sm font-bold">
                    <div className="px-4 py-2 bg-bluegray-500 rounded-lg">
                      株式の損益管理
                    </div>
                    <div className="px-4 py-2 ml-2 bg-bluegray-500 rounded-lg">
                      ポートフォリオの管理
                    </div>
                  </div>
                  <div className="mt-4 text-base leading-8">
                    複数の口座にある株式や投資信託の資産をまとめて表示できるアプリを使って、簡単にチェックできるようにしておくことがおすすめ。
                    <br />
                    たとえば投資管理アプリ「アセプラ」の資産管理チャート機能では、
                    <br />
                    <span
                      className="font-bold"
                      style={{
                        backgroundImage:
                          'linear-gradient(transparent 60%, #0891B2 0%)',
                      }}>
                      複数の証券口座にある資産の総額、前日比、銘柄ごとの損益、資産推移が一目で分かります。
                    </span>
                    <br />
                    保有資産や口座ごとに色分けされたチャートや、ポートフォリオで資産の内訳や増減がすぐにわかります。
                    <br />
                    複数の投資口座をどうやって管理したらいいかお悩みの投資家におすすめの機能です。
                    <br />
                    連携可能な金融商品は
                    <a
                      href="#linked_data"
                      target="_blank"
                      rel="noopener"
                      className="underline">
                      コチラから
                    </a>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div
                className="lg:hidden flex flex-col items-center py-12"
                id="sp-worries1"
                ref={worriesScroll}>
                <div className="flex justify-center">
                  <div className="px-2 text-sm font-bold bg-yellow-450 rounded-lg">
                    お悩み<span className="text-lg">1</span>
                  </div>
                </div>
                <div className="font-bold pt-4">
                  株式の<span className="text-23">資産推移</span>
                  を見える化したい
                </div>
                <h2 className="my-4 text-2xl font-bold text-center">
                  【解決方法】
                  <br />
                  すべての資産を
                  <br />
                  チャート・グラフで管理
                </h2>
                <div className="mx-4">
                  <img
                    src="/static/images/lp/worries1.png"
                    alt="資産管理をチャートが見やすくわかりやすい"
                    width="200"
                    height="400"
                    className=""
                  />
                </div>
                <div className="flex flex-row mt-4 text-xs font-bold">
                  <div className="px-4 py-2 bg-bluegray-500 rounded-lg">
                    株式の損益管理
                  </div>
                  <div className="px-4 py-2 ml-2 bg-bluegray-500 rounded-lg">
                    ポートフォリオの管理
                  </div>
                </div>
                <div className="mt-4 mx-4 text-base leading-8">
                  複数の口座にある株式や投資信託の資産をまとめて表示できるアプリを使って、簡単にチェックできるようにしておくことがおすすめ。
                  <br />
                  たとえば投資管理アプリ「アセプラ」の資産管理チャート機能では、
                  <br />
                  <span
                    className="font-bold"
                    style={{
                      backgroundImage:
                        'linear-gradient(transparent 60%, #0891B2 0%)',
                    }}>
                    複数の証券口座にある資産の総額、前日比、銘柄ごとの損益、資産推移が一目で分かります。
                  </span>
                  <br />
                  保有資産や口座ごとに色分けされたチャートや、ポートフォリオで資産の内訳や増減がすぐにわかります。
                  <br />
                  複数の投資口座をどうやって管理したらいいかお悩みの投資家におすすめの機能です。
                  <br />
                  連携可能な金融商品は
                  <a
                    href="#linked_data"
                    target="_blank"
                    rel="noopener"
                    className="underline">
                    コチラから
                  </a>
                </div>
              </div>
            </section>

            {/* 株式の資産推移を見える化したい　活用例 */}
            <section className="container flex flex-col mb-16 js-ui-animation-fadeup">
              <div className="flex flex-col items-center">
                <ul className="flex lg:flex-row flex-col justify-center lg:px-12 px-1">
                  <li className="w-full lg:max-w-panel-m lg:mt-4 mt-8 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例1
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      ポートフォリオを管理して
                      <br />
                      リスク分散に活用
                    </h3>
                    <div className="mx-2 mt-4">
                      <img
                        src="/static/images/lp/worries1_example1.png"
                        alt="ポートフォリオを管理してリスク分散に活用"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      口座ごと、資産ごとにポートフォリオを表示。複数口座にある資産の内訳がすぐにわかります。
                    </div>
                  </li>
                  <li className="w-full lg:max-w-panel-m mt-4 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例2
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      銘柄ごとに
                      <br />
                      損益をまとめて管理
                    </h3>
                    <div className="mx-8 mt-4">
                      <img
                        src="/static/images/lp/worries1_example2.png"
                        alt="銘柄ごとに損益をまとめて管理"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      国内株、外国株、投資信託、NISA、の損益を一覧で確認できます。日別、週別、月別で簡単に損益を管理できます。
                    </div>
                  </li>
                  <li className="w-full lg:max-w-panel-m mt-4 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例3
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      色分けされたグラフで
                      <br />
                      資産推移を確認
                    </h3>
                    <div className="mx-4 mt-4">
                      <img
                        src="/static/images/lp/worries1_example3.png"
                        alt="色分けされたグラフで資産推移を確認"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      国内株、外国株、投資信託、預金・MRFごとに色分けして、資産額や資産推移をグラフで表示します。1ヶ月、3ヶ月、1年など期間ごとに見ることもできます。
                    </div>
                  </li>
                </ul>
                <div className="mt-8 text-bluegray-700 text-base text-center lg:mx-0 mx-4">
                  ご利用には「みんかぶプレミアム会員」の登録が必要です。
                </div>
                {/* PC */}
                <div
                  className={`hidden lg:flex bg-gradient-to-r bg-gradient-r-red flex-col text-center text-xl w-full max-w-btn-l text-white leading-9 rounded-lg my-4 pt-4 pb-2 cursor-pointer hover:opacity-75 cv_premium`}>
                  <a href={linkRegist()}>
                    <div className="text-2xl font-bold">
                      資産をチャートで見てみる
                    </div>
                    <div className="flex justify-center mb-auto app-primary-label-block text-lg">
                      <div className="inline-flex items-center flex-col">
                        初回30日間無料
                      </div>
                    </div>
                  </a>
                </div>
                {/* SP */}
                <div className="lg:hidden flex w-full px-8">
                  <div
                    className={`bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-xl w-full max-w-btn-l py-2 mx-auto text-white rounded-lg mt-4 mb-8 cursor-pointer hover:opacity-75 cv_premium`}>
                    <a href={linkRegist()}>
                      <div className="text-lg font-bold">
                        資産をチャートで見てみる
                      </div>
                      <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                        <div className="inline-flex justify-center flex-col">
                          初回30日間無料
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* 複数の証券口座を1ヶ所で管理したい */}
            <section className="text-white bg-gray-800">
              {/* PC */}
              <div
                className="hidden lg:flex flex-row container w-full py-16 mb-12"
                id="worries2"
                ref={worriesScroll}>
                <div className="w-3/5 pr-10">
                  <div className="flex flex-row items-center">
                    <div className="px-2 text-sm font-bold bg-yellow-450 rounded-lg">
                      お悩み<span className="text-lg">2</span>
                    </div>
                    <div className="font-bold pl-2">
                      複数の証券口座を
                      <span className="text-23">1ヶ所で管理</span>
                      したい
                    </div>
                  </div>
                  <div className="mt-3 text-3xl font-bold">
                    <h2>
                      【解決方法】NISA、iDeCoも対応
                      <div className="text-right">複数口座をまとめて管理</div>
                    </h2>
                  </div>
                  <div className="flex flex-row mt-2 text-sm font-bold">
                    <div className="px-4 py-2 bg-bluegray-500 rounded-lg">
                      保有株の管理
                    </div>
                    <div className="px-4 py-2 ml-2 bg-bluegray-500 rounded-lg">
                      資産の一括管理
                    </div>
                  </div>
                  <div className="mt-4 text-base  leading-8">
                    <span
                      className="font-bold"
                      style={{
                        backgroundImage:
                          'linear-gradient(transparent 60%, #0891B2 0%)',
                      }}>
                      複数の証券口座を「老後資金」など目的別、「NISA」「つみたて投資」など運用方法別にグループを分けて
                    </span>
                    管理することができます。
                    <br />
                    グループごとに資産の合計額や資産推移もまとめて表示。それぞれの口座で保有する株式や投資信託を自分のルールでかんたんに管理できます。NISA口座、iDeCo口座も対応。
                  </div>
                </div>
                <div className="justify-center h-104 overflow-hidden relative">
                  <div className="login-app flex items-center justify-center login-app-banner">
                    <div className="flex justify-center w-full">
                      <div className="flex flex-col justify-end">
                        <div className="flex items-end justify-between mb-auto app-primary-label-block">
                          <div className="text-lg inline-flex items-center flex-col">
                            SBI証券の連携は無料！人気の楽天証券も対応
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="pt-4 text-center text-2xl font-bold">
                    <div className="flex flex-row items-center justify-center">
                      <div className="mx-4">SBI証券</div>
                      <div className="mx-4">楽天証券</div>
                    </div>
                  </div>
                  <div className="mt-4 text-base text-center">
                    ※ その他の証券会社はMoneytree連携で
                    <br />
                    一部の資産を管理できます
                  </div>
                  <div className="mt-10 mb-4 text-center text-lg">
                    連携可能な金融商品
                  </div>
                  <div className="w-4/5 mx-auto">
                    <div
                      className="grid items-start p-4 text-base font-bold text-gray-800 bg-white rounded-7 leading-3"
                      style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                      <div
                        className="flex flex-row items-center"
                        style={{ gridArea: '1 / 1' }}>
                        <img
                          src="/static/images/lp/square-check.png"
                          alt="チェックマーク"
                          className="pr-2"
                        />
                        <div>国内株</div>
                      </div>
                      <div
                        className="flex flex-row items-center"
                        style={{ gridArea: '1 / 2' }}>
                        <img
                          src="/static/images/lp/square-check.png"
                          alt="チェックマーク"
                          className="pr-2"
                        />
                        <div>NISA</div>
                      </div>
                      <div
                        className="flex flex-row items-center"
                        style={{ gridArea: '1 / 3' }}>
                        <img
                          src="/static/images/lp/square-check.png"
                          alt="チェックマーク"
                          className="pr-2"
                        />
                        <div>iDeCo</div>
                      </div>
                      <div
                        className="ml-6 text-1.5xs"
                        style={{ gridArea: '2 / 1' }}>
                        (現物/信用)
                      </div>
                      <div
                        className="flex flex-row items-center mt-2"
                        style={{ gridArea: '3 / 1' }}>
                        <img
                          src="/static/images/lp/square-check.png"
                          alt="チェックマーク"
                          className="pr-2"
                        />
                        <div>投資信託</div>
                      </div>
                      <div
                        className="flex flex-row items-center mt-2"
                        style={{ gridArea: '3 / 2' }}>
                        <img
                          src="/static/images/lp/square-check.png"
                          alt="チェックマーク"
                          className="pr-2"
                        />
                        <div>外国株</div>
                      </div>
                      <div
                        className="flex flex-row items-center mt-2"
                        style={{ gridArea: '3 / 3' }}>
                        <img
                          src="/static/images/lp/square-check.png"
                          alt="チェックマーク"
                          className="pr-2"
                        />
                        <div>米国株</div>
                      </div>
                    </div>
                  </div>

                  <div
                    className="text-sm pt-4 pl-18"
                    id="financialProductDetails">
                    対応する証券会社、金融商品の詳細は
                    <a href="#linked_data" rel="noopener" className="underline">
                      コチラから
                    </a>
                  </div>
                </div>
              </div>
              {/* SP */}
              <div
                className="lg:hidden flex flex-col items-center py-12"
                id="sp-worries2"
                ref={worriesScroll}>
                <div className="flex justify-center">
                  <div className="px-2 text-sm font-bold bg-yellow-450 rounded-lg">
                    お悩み<span className="text-lg">2</span>
                  </div>
                </div>
                <div className="font-bold pt-4">
                  複数の証券口座を<span className="text-23">1ヶ所で管理</span>
                  したい
                </div>
                <h2 className="my-4 text-2xl font-bold text-center">
                  【解決方法】
                  <br />
                  NISA、iDeCoも対応
                  <br />
                  複数口座をまとめて管理
                </h2>
                <div className="login-app flex items-center mt-4 mb-4 justify-center login-app-banner">
                  <div className="flex justify-center w-full">
                    <div className="flex flex-col justify-end">
                      <div className="flex items-end justify-between mb-auto app-primary-label-block">
                        <div className="text-sm inline-flex items-center flex-col">
                          SBI証券の連携は無料！人気の楽天証券も対応
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="text-center text-2xl font-bold mr-4">
                  <div className="flex flex-row items-center justify-center">
                    <div className="mx-2">SBI証券</div>
                    <div className="mx-2">楽天証券</div>
                  </div>
                </div>
                <div className="mt-4 text-base text-center">
                  ※ その他の証券会社はMoneytree連携で
                  <br />
                  一部の資産を管理できます
                </div>
                <div className="mt-6 mb-4 text-center">連携可能な金融商品</div>
                <div
                  className="grid items-start p-4 text-sm font-bold text-gray-800 bg-white rounded-7 leading-3"
                  style={{ gridTemplateColumns: '1fr 1fr 1fr' }}>
                  <div
                    className="flex flex-row items-center mr-3"
                    style={{ gridArea: '1 / 1' }}>
                    <img
                      src="/static/images/lp/square-check.png"
                      alt="チェックマーク"
                      className="pr-2"
                    />
                    <div>国内株</div>
                  </div>
                  <div
                    className="flex flex-row items-center mr-3"
                    style={{ gridArea: '1 / 2' }}>
                    <img
                      src="/static/images/lp/square-check.png"
                      alt="チェックマーク"
                      className="pr-2"
                    />
                    <div>NISA</div>
                  </div>
                  <div
                    className="flex flex-row items-center mr-3"
                    style={{ gridArea: '1 / 3' }}>
                    <img
                      src="/static/images/lp/square-check.png"
                      alt="チェックマーク"
                      className="pr-2"
                    />
                    <div>iDeCo</div>
                  </div>
                  <div
                    className="ml-5 text-1.5xs"
                    style={{ gridArea: '2 / 1' }}>
                    (現物/信用)
                  </div>
                  <div
                    className="flex flex-row items-center mr-3 mt-2"
                    style={{ gridArea: '3 / 1' }}>
                    <img
                      src="/static/images/lp/square-check.png"
                      alt="チェックマーク"
                      className="pr-2"
                    />
                    <div>投資信託</div>
                  </div>
                  <div
                    className="flex flex-row items-center mr-3 mt-2"
                    style={{ gridArea: '3 / 2' }}>
                    <img
                      src="/static/images/lp/square-check.png"
                      alt="チェックマーク"
                      className="pr-2"
                    />
                    <div>外国株</div>
                  </div>
                  <div
                    className="flex flex-row items-center mr-3 mt-2"
                    style={{ gridArea: '3 / 3' }}>
                    <img
                      src="/static/images/lp/square-check.png"
                      alt="チェックマーク"
                      className="pr-2"
                    />
                    <div>米国株</div>
                  </div>
                </div>
                <div
                  className="text-sm my-4 text-center"
                  id="financialProductDetails">
                  対応する証券会社、金融商品の詳細は
                  <a href="#linked_data" rel="noopener" className="underline">
                    コチラから
                  </a>
                </div>

                <div className="flex flex-row mt-4 text-xs font-bold">
                  <div className="px-4 py-2 bg-bluegray-500 rounded-lg">
                    保有株の管理
                  </div>
                  <div className="px-4 py-2 ml-2 bg-bluegray-500 rounded-lg">
                    資産の一括管理
                  </div>
                </div>
                <div className="mt-4 mx-4 text-base leading-8">
                  <span
                    className="font-bold"
                    style={{
                      backgroundImage:
                        'linear-gradient(transparent 60%, #0891B2 0%)',
                    }}>
                    複数の証券口座を「老後資金」など目的別、「NISA」「つみたて投資」など運用方法別にグループを分けて
                  </span>
                  管理することができます。
                  <br />
                  グループごとに資産の合計額や資産推移もまとめて表示。それぞれの口座で保有する株式や投資信託を自分のルールでかんたんに管理できます。NISA口座、iDeCo口座も対応。
                </div>
              </div>
            </section>

            {/* 複数の証券口座を1ヶ所で管理したい　活用例 */}
            <section className="container flex flex-col mb-16 js-ui-animation-fadeup">
              <div className="flex flex-col items-center">
                <ul className="flex lg:flex-row flex-col justify-center lg:px-12 px-1">
                  <li className="w-full lg:max-w-panel-m lg:mt-4 mt-8 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例1
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      老後資金など
                      <br />
                      目的別に口座を管理
                    </h3>
                    <div className="mx-2 mt-4">
                      <img
                        src="/static/images/lp/worries2_example1.png"
                        alt="老後資金など目的別に口座を管理"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      証券口座を「老後資金」「マイホーム資金」など目的別に管理できます。それぞれの資産額や損益もわかるため、用途別に投資を管理したい方におすすめです。
                    </div>
                  </li>
                  <li className="w-full lg:max-w-panel-m mt-4 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例2
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      NISA、積立投資など
                      <br />
                      運用別に口座を管理
                    </h3>
                    <div className="mx-2 mt-4">
                      <img
                        src="/static/images/lp/worries2_example2.png"
                        alt="NISA、積立投資など運用別に口座を管理"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      「NISA」「iDeCo」「積立投資」など、運用別に口座をグループ分けし、損益の管理ができます。運用別に複数の証券口座を使い分けている方におすすめです。
                    </div>
                  </li>
                  <li className="w-full lg:max-w-panel-m mt-4 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例3
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      「子ども用」など
                      <br />
                      家族ごとに資産を管理
                    </h3>
                    <div className="mx-2 mt-4">
                      <img
                        src="/static/images/lp/worries2_example3.png"
                        alt="「子ども用」など家族ごとに資産を管理"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      家族ごとに口座をグループ分けすることもできます。
                      <br />
                      家族の資産をまとめて管理したい方におすすめです。
                    </div>
                  </li>
                </ul>
                <div className="mt-8 text-bluegray-700 text-base text-center lg:mx-0 mx-4">
                  ご利用には「みんかぶプレミアム会員」の登録が必要です。
                </div>
                {/* PC */}
                <div
                  className={`hidden lg:flex bg-gradient-to-r bg-gradient-r-red flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 rounded-lg my-4 pt-4 pb-2 cursor-pointer hover:opacity-7 cv_premium`}>
                  <a href={linkRegist()}>
                    <div className="text-2xl font-bold">
                      資産を目的別に管理する
                    </div>
                    <div className="flex justify-center mb-auto app-primary-label-block text-lg">
                      <div className="inline-flex items-center flex-col">
                        初回30日間無料
                      </div>
                    </div>
                  </a>
                </div>
                {/* SP */}
                <div className="lg:hidden flex w-full px-8">
                  <div
                    className={`bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-xl w-full max-w-btn-l py-2 mx-auto text-white rounded-lg mt-4 mb-8 cursor-pointer hover:opacity-75 cv_premium`}>
                    <a href={linkRegist()}>
                      <div className="text-lg font-bold">
                        資産を目的別に管理する
                      </div>
                      <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                        <div className="inline-flex justify-center flex-col">
                          初回30日間無料
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* 自分の取引の傾向を知りたい */}
            <section className="text-white bg-gray-800">
              {/* PC */}
              <div
                className="hidden lg:flex container w-full pt-16 mb-12"
                id="worries3"
                ref={worriesScroll}>
                <div className="w-1/3 flex justify-center h-116 overflow-hidden relative">
                  <img
                    src="/static/images/lp/worries3.png"
                    alt="資産管理をチャートが見やすくわかりやすい"
                    width="340"
                    height="550"
                    className="image top-0 absolute object-cover"
                  />
                </div>
                <div className="w-2/3 pl-10">
                  <div className="flex flex-row items-center">
                    <div className="px-2 text-sm font-bold bg-yellow-450 rounded-lg">
                      お悩み<span className="text-lg">3</span>
                    </div>
                    <div className="font-bold pl-2">
                      自分の<span className="text-23">取引の傾向</span>
                      を知りたい
                    </div>
                  </div>
                  <h2 className="flex flex-col mt-3 text-3xl font-bold">
                    【解決方法】取引履歴チャートで
                    <span className="text-right">投資の傾向がわかる</span>
                  </h2>
                  <div className="flex flex-row mt-2 text-sm font-bold">
                    <div className="px-4 py-2 bg-bluegray-500 rounded-lg">
                      取引履歴の保存
                    </div>
                    <div className="px-4 py-2 ml-2 bg-bluegray-500 rounded-lg">
                      チャート分析
                    </div>
                  </div>
                  <div className="mt-4 text-base leading-8">
                    どんな時に自分が取引しているか振り返りましょう！
                    <br />
                    <span
                      className="font-bold"
                      style={{
                        backgroundImage:
                          'linear-gradient(transparent 60%, #0891B2 0%)',
                      }}>
                      株式や投資信託の売買を株価チャートに記録し、取引タイミングを分析することが大切です。
                    </span>
                    アセプラでは、国内株、米国株、投資信託、NISAに対応。株価チャートは数ヶ月単位で表示できるため、過去の投資の分析にも便利です。
                    <br />
                    複数の証券口座の投資をまとめて分析し、次の取引に役立てたい方におすすめです。
                  </div>
                </div>
              </div>
              {/* SP */}
              <div
                className="lg:hidden flex flex-col items-center py-12"
                id="sp-worries3"
                ref={worriesScroll}>
                <div className="flex justify-center">
                  <div className="px-2 text-sm font-bold bg-yellow-450 rounded-lg">
                    お悩み<span className="text-lg">3</span>
                  </div>
                </div>
                <div className="font-bold pt-4">
                  自分の<span className="text-23">取引の傾向</span>
                  を知りたい
                </div>
                <div className="my-4 text-2xl font-bold text-center">
                  <h2>
                    【解決方法】
                    <br />
                    取引履歴チャートで
                    <br />
                    投資の傾向がわかる
                  </h2>
                </div>
                <div className="mx-4">
                  <img
                    src="/static/images/lp/worries3.png"
                    alt="老株の売買履歴がスマホでわかる"
                    width="200"
                    height="400"
                    className=""
                  />
                </div>
                <div className="flex flex-row mt-4 text-xs font-bold">
                  <div className="px-4 py-2 bg-bluegray-500 rounded-lg">
                    取引履歴の保存
                  </div>
                  <div className="px-4 py-2 ml-2 bg-bluegray-500 rounded-lg">
                    チャート分析
                  </div>
                </div>
                <div className="mt-4 mx-4 text-base leading-8">
                  どんな時に自分が取引しているか振り返りましょう！
                  <br />
                  <span
                    className="font-bold"
                    style={{
                      backgroundImage:
                        'linear-gradient(transparent 60%, #0891B2 0%)',
                    }}>
                    株式や投資信託の売買を株価チャートに記録し、取引タイミングを分析することが大切です。
                  </span>
                  <br />
                  アセプラでは、国内株、米国株、投資信託、NISAに対応。株価チャートは数ヶ月単位で表示できるため、過去の投資の分析にも便利です。
                  <br />
                  複数の証券口座の投資をまとめて分析し、次の取引に役立てたい方におすすめです。
                </div>
              </div>
            </section>

            {/* 自分の取引の傾向を知りたい　活用例 */}
            <section className="container flex flex-col mb-16 js-ui-animation-fadeup">
              <div className="flex flex-col items-center">
                <ul className="flex lg:flex-row flex-col justify-center lg:px-12 px-1">
                  <li className="w-full lg:max-w-panel-m lg:mt-4 mt-8 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例1
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      投資の傾向をつかみ
                      <br />
                      次の取引に役立てる
                    </h3>
                    <div className="mx-2 mt-4">
                      <img
                        src="/static/images/lp/worries3_example1.png"
                        alt="投資の傾向をつかみ次の取引に役立てる"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      取引履歴ツールでは、株式や投資信託の売買タイミングを株価チャートで確認できます。
                      <br />
                      過去の売買タイミングから投資の傾向をつかみ、今後の取引に活用できます。
                    </div>
                  </li>
                  <li className="w-full lg:max-w-panel-m mt-4 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例2
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      期間や取引区分ごとに
                      <br />
                      合計損益がわかる
                    </h3>
                    <div className="mx-2 mt-4">
                      <img
                        src="/static/images/lp/worries3_example2.png"
                        alt="チャート上で売買履歴がスマホでわかる"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      株式や投資信託の取引履歴を、「現物/信用」などの取引区分や期間ごとに絞り込み、一覧で見ることができます。
                      <br />
                      銘柄ごとに確定損益を知りたいときに便利です。
                    </div>
                  </li>
                </ul>
                <div className="mt-8 text-bluegray-700 text-base text-center lg:mx-0 mx-4">
                  ご利用には「みんかぶプレミアム会員」の登録が必要です。
                </div>
                {/* PC */}
                <div
                  className={`hidden lg:flex bg-gradient-to-r bg-gradient-r-red flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 rounded-lg my-4 pt-4 pb-2 cursor-pointer hover:opacity-75 cv_premium`}>
                  <a href={linkRegist()}>
                    <div className="text-2xl font-bold">取引履歴を見てみる</div>
                    <div className="flex justify-center mb-auto app-primary-label-block text-lg">
                      <div className="inline-flex items-center flex-col">
                        初回30日間無料
                      </div>
                    </div>
                  </a>
                </div>
                {/* SP */}
                <div className="lg:hidden flex w-full px-8">
                  <div
                    className={`bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-xl w-full max-w-btn-l py-2 mx-auto text-white rounded-lg mt-4 mb-8 cursor-pointer hover:opacity-75 cv_premium`}>
                    <a href={linkRegist()}>
                      <div className="text-lg font-bold">
                        取引履歴を見てみる
                      </div>
                      <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                        <div className="inline-flex justify-center flex-col">
                          初回30日間無料
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* 複数口座の損益をまとめて知りたい */}
            <section className="text-white bg-gray-800">
              {/* PC */}
              <div
                className="hidden lg:flex flex-row container pt-16 mb-12"
                id="worries4"
                ref={worriesScroll}>
                <div className="w-2/3 pr-10">
                  <div className="flex flex-row items-center">
                    <div className="px-2 text-sm font-bold bg-yellow-450 rounded-lg">
                      お悩み<span className="text-lg">4</span>
                    </div>
                    <div className="font-bold pl-2">
                      <span className="text-23">複数口座の損益</span>
                      をまとめて知りたい
                    </div>
                  </div>
                  <div className="flex mt-3 text-3xl font-bold">
                    <h2>
                      【解決方法】
                      <span className="mr-auto">LINEで投資の損益がわかる</span>
                    </h2>
                  </div>
                  <div className="flex flex-row mt-4 text-sm font-bold">
                    <div className="px-4 py-2 bg-bluegray-500 rounded-lg">
                      投資の収支管理
                    </div>
                    <div className="px-4 py-2 ml-2 bg-bluegray-500 rounded-lg">
                      LINE通知
                    </div>
                  </div>
                  <div className="mt-4 text-base leading-8">
                    複数口座の損益をまとめて通知するアプリを使うことがおすすめです。
                    <br />
                    アセプラでは、複数口座にある株式や投資信託の損益、あなたの資産総額を毎日レポート。LINEで見ることもできます。
                    <br />
                    <span
                      className="font-bold"
                      style={{
                        backgroundImage:
                          'linear-gradient(transparent 60%, #0891B2 0%)',
                      }}>
                      どの口座の銘柄が増えた・減ったかが一目でわかるため、売買タイミングを逃したくない投資家におすすめです。
                    </span>
                    <div className="pt-8">
                      資産レポートは、週ごと、月ごとにも配信。資産推移をグラフで表示し、口座別の資産変動もわかります。iDeCo口座も対応。
                      <br />
                      複数の証券口座の損益をまとめて管理したい方におすすめです。
                    </div>
                  </div>
                </div>
                <div className="w-1/3 flex justify-center h-116 overflow-hidden relative">
                  <img
                    src="/static/images/lp/worries4.svg"
                    alt="LINEで投資の損益がわかる"
                    width="340"
                    height="550"
                    className="image top-0 absolute object-cover pt-1"
                  />
                </div>
              </div>
              {/* SP */}
              <div
                className="lg:hidden flex flex-col items-center py-12"
                id="sp-worries4"
                ref={worriesScroll}>
                <div className="flex justify-center">
                  <div className="px-2 text-sm font-bold bg-yellow-450 rounded-lg">
                    お悩み<span className="text-lg">4</span>
                  </div>
                </div>
                <div className="font-bold pt-4">
                  <span className="text-23">複数口座の損益</span>
                  をまとめて知りたい
                </div>
                <h2 className="my-4 text-2xl font-bold text-center">
                  【解決方法】
                  <br />
                  LINEで投資の損益がわかる
                </h2>
                <div className="mx-4">
                  <img
                    src="/static/images/lp/worries4.svg"
                    alt="LINEで投資の損益がわかる"
                    width="200"
                    height="400"
                    className=""
                  />
                </div>
                <div className="flex flex-row mt-4 text-xs font-bold">
                  <div className="px-3 py-2 bg-bluegray-500 rounded-lg">
                    投資の収支管理
                  </div>
                  <div className="px-4 py-2 ml-2 bg-bluegray-500 rounded-lg">
                    LINE通知
                  </div>
                </div>
                <div className="mt-4 mx-4 text-base leading-8">
                  複数口座の損益をまとめて通知するアプリを使うことがおすすめです。
                  <br />
                  アセプラでは、複数口座にある株式や投資信託の損益、あなたの資産総額を毎日レポート。LINEで見ることもできます。
                  <br />
                  <span
                    className="font-bold"
                    style={{
                      backgroundImage:
                        'linear-gradient(transparent 60%, #0891B2 0%)',
                    }}>
                    どの口座の銘柄が増えた・減ったかが一目でわかるため、売買タイミングを逃したくない投資家におすすめです。
                  </span>
                  <br />
                  <br />
                  資産レポートは、週ごと、月ごとにも配信。資産推移をグラフで表示し、口座別の資産変動もわかります。iDeCo口座も対応。
                  <br />
                  複数の証券口座の損益をまとめて管理したい方におすすめです。
                </div>
              </div>
            </section>

            {/* 複数口座の損益をまとめて知りたい　活用例 */}
            <section className="container flex flex-col mb-16 js-ui-animation-fadeup">
              <div className="flex flex-col items-center">
                <ul className="flex lg:flex-row flex-col justify-center lg:px-12 px-1">
                  <li className="w-full lg:max-w-panel-m lg:mt-4 mt-8 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例1
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      資産変動が毎日分かるから
                      <br />
                      売買タイミングを逃さない
                    </h3>
                    <div className="mx-2 mt-4">
                      <img
                        src="/static/images/lp/worries4_example1.png"
                        alt="資産変動が毎日わかるから売買タイミングを逃さない"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      日ごと、週ごと、月ごとのレポートで、複数の証券口座の資産推移をチャートで見たり、株式や投資信託の損益を管理できます。
                    </div>
                  </li>
                  <li className="w-full lg:max-w-panel-m mt-4 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例2
                    </div>
                    <h3 className="text-lg font-bold text-center">
                      最新の資産情報を
                      <br />
                      LINEで受け取れる
                    </h3>
                    <div className="mx-2 mt-4">
                      <img
                        src="/static/images/lp/worries4_example2.png"
                        alt="最新の資産情報をLINEで受け取れる"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      レポートはLINEで見ることもできます。
                      大きく資産が変動した口座や、銘柄ごとの損益などが毎日わかるため、売買タイミングを逃したくない方におすすめです。
                    </div>
                  </li>
                  <li className="w-full lg:max-w-panel-m mt-4 lg:mx-2 px-2 py-4 border border-bluegray-300 rounded-lg bg-white">
                    <div className="text-lg text-center text-cyan-600">
                      活用例3
                    </div>
                    <h3 className="mt-2 text-lg font-bold text-center">
                      週ごとの損益ランキングで
                      <br />
                      銘柄の分析にも
                    </h3>
                    <div className="mx-2 mt-4">
                      <img
                        src="/static/images/lp/worries4_example3.svg"
                        alt="週ごとの損益ランキングで銘柄の分析にも"
                        className="w-full"
                      />
                    </div>
                    <div className="text-base mt-4 mx-2">
                      週1のレポートでは、株式、投資信託の損益をランキング形式でお知らせします。
                      <br />
                      保有銘柄の損益を比べて、銘柄の分析に活用できます。
                    </div>
                  </li>
                </ul>
                <div className="mt-8 text-bluegray-700 text-base text-center lg:mx-0 mx-4">
                  ご利用には「みんかぶプレミアム会員」の登録が必要です。
                </div>
                {/* PC */}
                <div
                  className={`hidden lg:flex bg-gradient-to-r bg-gradient-r-red flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 rounded-lg my-4 pt-4 pb-2 cursor-pointer hover:opacity-75 cv_premium`}>
                  <a href={linkRegist()}>
                    <div className="text-2xl font-bold">
                      資産レポートを使ってみる
                    </div>
                    <div className="flex justify-center mb-auto app-primary-label-block text-lg">
                      <div className="inline-flex items-center flex-col">
                        初回30日間無料
                      </div>
                    </div>
                  </a>
                </div>
                {/* SP */}
                <div className="lg:hidden flex w-full px-8">
                  <div
                    className={`bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-xl w-full max-w-btn-l py-2 mx-auto text-white rounded-lg mt-4 mb-8 cursor-pointer hover:opacity-75 cv_premium`}>
                    <a href={linkRegist()}>
                      <div className="text-lg font-bold">
                        資産レポートを使ってみる
                      </div>
                      <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                        <div className="inline-flex justify-center flex-col">
                          初回30日間無料
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </section>

            {/* 個人投資家の口コミ */}
            <section className="lg:pb-18 pb-12 pt-12 bg-cyan-450">
              <div className="lg:mb-8 mb-2 lg:text-3.5xl text-xl font-bold text-center text-white">
                個人投資家の口コミ
              </div>
              <ul className="lg:flex justify-center lg:text-2xl lg:leading-8 lg:mb-12 w-full px-1 lg:px-12">
                <li className="lg:max-w-panel-m flex flex-col items-center py-6 px-4 mb-4 lg:mb-0 text-base bg-white border border-solid rounded-lg">
                  <div>
                    <img
                      src="/static/images/lp/person1.png"
                      alt="30代資産形成"
                      width="140"
                      height="140"
                      className="mx-auto"
                    />
                  </div>
                  <div className="mt-2 text-center">30代　投資歴：1年</div>
                  <div className="font-bold text-center">
                    複数口座の収支をまとめられる
                  </div>
                  <div className="mt-3 pt-2 border-t border-dashed border-bluegray-300">
                    複数の証券口座で投資していると、それぞれの口座の収支を管理するのが大変だが、このアプリはチャートやグラフで資産の合計額や銘柄ごとの損益がわかるため助かっています。
                  </div>
                </li>
                <li className="lg:max-w-panel-m flex flex-col items-center py-6 px-4 mb-4 lg:mb-0 lg:ml-8 text-base bg-white border border-solid rounded-lg">
                  <div>
                    <img
                      src="/static/images/lp/person5.png"
                      alt="50代資産形成"
                      width="140"
                      height="140"
                      className="mx-auto"
                    />
                  </div>
                  <div className="mt-2 text-center">50代　投資歴：30年</div>
                  <div className="font-bold text-center">
                    お金を貯める目的別に口座を管理できる
                  </div>
                  <div className="mt-3 pt-2 border-t border-dashed border-bluegray-300">
                    証券口座を「老後資金用」「旅行用」などグループを分けて管理しています。目的ごとにしっかりお金が増えているのがわかるとモチベーションも上がります。
                  </div>
                </li>
                <li className="lg:max-w-panel-m flex flex-col items-center py-6 px-4 mb-4 lg:mb-0 lg:ml-8 text-base bg-white border border-solid rounded-lg">
                  <div>
                    <img
                      src="/static/images/lp/person2.png"
                      alt="40代資産形成"
                      width="140"
                      height="140"
                      className="mx-auto"
                    />
                  </div>
                  <div className="mt-2 text-center">40代　投資歴：7年</div>
                  <div className="font-bold text-center">
                    株式の損益がLINEでわかる
                  </div>
                  <div className="mt-3 pt-2 border-t border-dashed border-bluegray-300">
                    仕事と育児で時間がないため、資産レポートとLINEを連携し、株式の損益をまとめてチェックしています。資産の増減が毎日わかるため、売買タイミングを判断するのにも便利です。
                  </div>
                </li>
              </ul>
            </section>

            {/* 資産管理ツールは『アセプラ』がおすすめ */}
            <section className="flex flex-col items-center pb-18 pt-12 lg:px-34 bg-cyan-600 text-white">
              <div className="container w-full">
                <h2 className="lg:text-3.5xl text-2xl font-bold text-center">
                  投資管理アプリは
                  <br />
                  『アセプラ』 がおすすめ
                </h2>
                {/* PC */}
                <div className="hidden lg:flex flex-col items-center mt-8">
                  <div className="flex flex-row justify-center items-center">
                    <div className="w-2/5">
                      <div className="text-xl font-bold">
                        あなたの資産のうごきが１分でわかる
                      </div>
                      <div className="leading-8">
                        いくつもある証券口座をまとめて管理。
                        <br />
                        チャートやグラフの分かりやすい画面で、株式、投資信託の損益や資産の推移がひと目でわかります。
                        <br />
                        各口座にログインして確認する手間から解放されたい投資家にもおすすめです。
                      </div>
                    </div>
                    <div className="w-3/5 ml-4">
                      <img
                        src="/static/images/lp/smartphones.png"
                        alt="資産形成ツール「みんかぶアセットプランナー」、「アセプラ」"
                        className="w-full"
                      />
                    </div>
                  </div>
                  <div className="mt-8 text-white text-base text-center">
                    ご利用には「みんかぶプレミアム会員」の登録が必要です。
                  </div>

                  <div
                    className={`bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 rounded-lg my-4 pt-4 pb-2 cursor-pointer hover:opacity-75 cv_premium`}>
                    <a href={linkRegist()}>
                      <div className="text-2xl font-bold">
                        アセプラを使ってみる
                      </div>
                      <div className="flex justify-center mb-auto app-primary-label-block text-lg">
                        <div className="inline-flex items-center flex-col">
                          初回30日間無料
                        </div>
                      </div>
                    </a>
                  </div>
                </div>
                {/* SP */}
                <div className="lg:hidden flex flex-col items-center mt-2 mx-4">
                  <div className="mx-2">
                    <img
                      src="/static/images/lp/smartphones.png"
                      alt="資産形成ツール「みんかぶアセットプランナー」、「アセプラ」"
                      className="w-full"
                    />
                  </div>
                  <div className="mt-3 text-lg font-bold">
                    あなたの資産のうごきが１分でわかる
                  </div>
                  <div className="mt-3 text-base leading-8">
                    いくつもある証券口座をまとめて管理。
                    <br />
                    チャートやグラフの分かりやすい画面で、株式、投資信託の損益や資産の推移がひと目でわかります。
                    <br />
                    各口座にログインして確認する手間から解放されたい投資家にもおすすめです。
                  </div>
                  <div className="mt-8 text-white text-base text-center">
                    ご利用には「みんかぶプレミアム会員」の登録が必要です。
                  </div>
                  <div className="w-full px-4">
                    <div
                      className={`bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-xl w-full max-w-btn-l py-2 mx-auto text-white rounded-lg mt-4 cursor-pointer hover:opacity-75 cv_premium`}>
                      <a href={linkRegist()}>
                        <div className="text-lg font-bold">
                          アセプラを使ってみる
                        </div>
                        <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                          <div className="inline-flex justify-center flex-col">
                            初回30日間無料
                          </div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/* 資産形成が一歩進む、お金の勉強 */}
            <section className="flex flex-col items-center px-2 lg:pt-16 pt-12 lg:pb-16 pb-12 lg:px-4 bg-white">
              <div className="lg:mb-8 mb-4">
                <h2
                  id="finance_study"
                  className="lg:text-3xl text-xl font-bold mb-2 leading-6">
                  資産形成が一歩進む、お金の勉強
                </h2>
                <div className="hidden lg:flex h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>
              <div className="lg:px-4 lg:w-1/2 w-full h-72 min-h-full">
                <iframe
                  width="100%"
                  height="100%"
                  src="https://www.youtube.com/embed/c15FmbOB_14"
                  title="YouTube video player"
                  className=""
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
              </div>
              {/* PC */}
              <div className="hidden lg:flex mt-8 text-2xl font-bold">
                『資産形成入門』なんとなく貯金を見直そう！
              </div>
              {/* SP */}
              <div className="lg:hidden flex mt-8 text-base font-bold text-center">
                『資産形成入門』
                <br />
                なんとなく貯金を見直そう！
              </div>
            </section>

            {/*データ連携可能な口座*/}
            <section className="bg-white pt-16 pb-16 js-ui-animation-fadeup lg:px-8 px-4">
              <div className="text-center mb-12">
                <h2
                  id="data"
                  className="text-xl font-bold mb-2 lg:text-3xl lg:mb-4">
                  データ連携可能な口座
                </h2>
                <div className="h-4 w-64 bg-red-500 right-half mx-auto"></div>
              </div>
              {/*口座連携可能な証券会社*/}
              <div className="container">
                <div className="mb-8 text-center">
                  <h3 id="data_com" className="text-lg font-bold mb-2">
                    口座連携可能な証券会社
                  </h3>
                  <p className="text-bluegray-500 text-sm">
                    連携可能な証券会社と金融商品は今後追加していく予定です。
                  </p>
                </div>
                <div
                  className="grid justify-center"
                  style={{ gridTemplateColumns: 'auto auto' }}>
                  <div className="flex flex-row justify-center mx-3.5">
                    <div className="px-1">
                      <div className="px-6 bg-tradewell text-white rounded-full">
                        無料
                      </div>
                    </div>
                    <div className="px-1 text-lg font-bold text-red-500">
                      SBI証券
                    </div>
                  </div>
                  <div className="mx-3.5 text-lg font-bold">楽天証券</div>
                </div>
                {/* PC */}
                <div className="mt-10 text-base font-bold text-center">
                  口座連携準備中の証券会社
                </div>
                <div className="lg:flex hidden flex-col">
                  <div className="flex flex-row items-cener justify-center pt-8 text-base">
                    <div className="text-center mx-8">松井証券</div>
                    <div className="text-center mx-8">マネックス証券</div>
                    <div className="text-center mx-8">野村證券</div>
                    <div className="text-center mx-8">大和証券</div>
                    <div className="text-center mx-8">SMBC日興証券</div>
                  </div>
                  <div className="flex flex-row items-cener justify-center pt-4 text-base">
                    <div className="text-center mx-8">みずほ証券</div>
                    <div className="text-center mx-8">
                      岡三証券
                      <span className="text-sm font-normal">※1</span>
                    </div>
                    <div className="text-center mx-8">
                      三菱UFJ eスマート証券
                      <span className="text-sm font-normal">※2</span>
                    </div>
                    <div className="text-center mx-8">
                      三菱UFJモルガン・スタンレー証券
                    </div>
                  </div>
                </div>
                {/* SP */}
                <div className="lg:hidden flex text-base text-center">
                  <div>
                    <div className="inline-block pt-4 px-4">松井証券</div>
                    <div className="inline-block pt-4 px-4">マネックス証券</div>
                    <div className="inline-block pt-4 px-4">野村證券</div>
                    <div className="inline-block pt-4 px-4">大和証券</div>
                    <div className="inline-block pt-4 px-4">SMBC日興証券</div>
                    <div className="inline-block pt-4 px-4">みずほ証券</div>
                    <div className="inline-block pt-4 px-4">
                      岡三証券
                      <span className="text-sm font-normal">※1</span>
                    </div>
                    <div className="inline-block pt-4 px-4">
                      三菱UFJ eスマート証券
                      <span className="text-sm font-normal">※2</span>
                    </div>
                    <div className="inline-block pt-4 px-4">
                      三菱UFJモルガン・スタンレー証券
                    </div>
                  </div>
                </div>
                <div className="pt-4 text-center text-sm">
                  ※1 旧岡三オンライン証券を除く
                </div>
                <div className="text-center text-sm">※2 旧auカブコム証券</div>
                <div className="pt-2 text-center text-sm text-bluegray-500">
                  ※口座連携準備中の証券会社はMoneytreeと連携することで一部の資産を管理できます
                </div>
                {/*スクロールさせる*/}
                {/* PC */}
                <div className="hidden lg:flex mt-8 justify-center">
                  <table className="w-full table-fixed">
                    <thead>
                      <tr className="h-16 bg-bluegray-50">
                        <th className="border-b border-gray-300 font-normal text-base">
                          連携可能な金融商品
                        </th>
                        <th className="border-b border-gray-300 font-normal">
                          <div className="text-sm">国内株式</div>
                          <div className="text-sm">(現物/信用)</div>
                        </th>
                        <th className="border-b border-gray-300 font-normal">
                          <div className="text-sm">米国株式</div>
                          <div className="text-sm">(現物のみ)</div>
                        </th>
                        <th className="border-b border-gray-300 font-normal">
                          <div className="text-sm">外国株式</div>
                          <div className="text-sm">(現物のみ)</div>
                        </th>
                        <th className="border-b border-gray-300 font-normal text-base">
                          投資信託
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="h-16">
                        <td className="border-b border-gray-300 text-center">
                          各証券会社
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                {/* SP */}
                <div className="flex lg:hidden mt-8 justify-center">
                  <table className="w-full table-fixed">
                    <thead>
                      <tr className="h-16">
                        <th className="bg-bluegray-50 border-b border-gray-300 font-normal text-base">
                          連携可能な金融商品
                        </th>
                        <th className="border-b border-gray-300 font-normal">
                          <div className="text-base">各証券会社</div>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr className="h-16">
                        <td className="bg-bluegray-50 border-b border-gray-300 text-center">
                          <div className="text-sm">国内株式</div>
                          <div className="text-sm">(現物/信用)</div>
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                      <tr className="h-16">
                        <td className="bg-bluegray-50 border-b border-gray-300 text-center">
                          <div className="text-sm">米国株式</div>
                          <div className="text-sm">(現物のみ)</div>
                        </td>
                        <td className="border-b border-gray-300 text-center text-sm">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                      <tr className="h-16">
                        <td className="bg-bluegray-50 border-b border-gray-300 text-center">
                          <div className="text-sm">外国株式</div>
                          <div className="text-sm">(現物のみ)</div>
                        </td>
                        <td className="border-b border-gray-300 text-center text-sm">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                      <tr className="h-16">
                        <td className="bg-bluegray-50 border-b border-gray-300 text-center text-base">
                          投資信託
                        </td>
                        <td className="border-b border-gray-300 text-center">
                          <p className="text-2xl font-bold text-red-500">○</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className="border-b border-gray-300 pb-8">
                  <div className="mt-4 text-center leading-5 text-sm">
                    <div>
                      特定口座/NISA口座/一般口座
                      <span className="text-1.5xs text-bluegray-500">※</span>
                      　に対応しています。
                    </div>
                    <div className="text-bluegray-500">
                      ※一般口座では保有株式については反映されますが損益は不明なため反映されません
                    </div>
                    <div className="text-bluegray-500">
                      ※現在、マネックス証券と総合証券は取引履歴は表示されません
                    </div>
                  </div>
                </div>
                <div className="mb-8 text-center border-b border-gray-300 py-8">
                  <h3
                    id="data_moneytree"
                    className="text-lg font-bold lg:text-center mb-4">
                    確定拠出年金口座
                  </h3>
                  <div className="lg:flex hidden flex-col mx-40 text-lg font-bold">
                    <div className="flex flex-row justify-between pt-4">
                      <div className="pr-6">SBI ベネフィット・システムズ</div>
                      <div className="">
                        日本レコード・キーピング・ネットワーク（NRK）
                      </div>
                    </div>
                    <div className="pt-4 pr-3 text-left">
                      日本インベスター・ソリューション・アンド・テクノロジー（JIS&T）
                    </div>
                  </div>
                  <div className="lg:hidden flex text-base font-bold text-center">
                    <div>
                      <div className="inline-block pt-4">
                        SBI ベネフィット・システムズ
                      </div>
                      <div className="inline-block pt-4">
                        日本レコード・キーピング・ネットワーク（NRK）
                      </div>
                      <div className="inline-block pt-4">
                        日本インベスター・ソリューション・アンド・テクノロジー（JIS&T）
                      </div>
                    </div>
                  </div>
                </div>
                {/*口座残高データを連携可能な証券会社*/}
                <div className="mb-8 text-center border-b border-gray-300 py-8">
                  <h3
                    id="data_moneytree"
                    className="text-lg font-bold lg:text-center mb-4">
                    上記以外の金融機関はMoneytreeで連携可能です
                    <br />
                    <span className="text-sm">(マネーツリー対応口座)</span>
                  </h3>
                  <ul className="text-sm">
                    <li className="inline-block mb-2 px-0.5">
                      GMOクリック証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      SBI ベネフィット・システムズ確定拠出年金 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      SBIネオトレード証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      SBIネオモバイル証券 /
                    </li>
                    <li className="inline-block  px-3 mb-2">SBI証券 /</li>
                    <li className="inline-block mb-2 px-0.5">SMBC日興証券 /</li>
                    <li className="inline-block px-3  mb-2">THEO /</li>
                    <li className="inline-block mb-2 px-0.5">WealthNavi /</li>
                    <li className="inline-block px-3 b-2">オリックス生命 /</li>
                    <li className="inline-block mb-2 px-0.5">セゾン投信 /</li>
                    <li className="inline-block mb-2 px-0.5">
                      マネックス証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">みずほ証券 /</li>
                    <li className="inline-block mb-2 px-0.5">ネット倶楽部 /</li>
                    <li className="inline-block mb-2 px-0.5">
                      よこしん投信（横浜信用金庫） /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      岡三オンライン証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">楽天証券 /</li>
                    <li className="inline-block mb-2 px-0.5">
                      三菱ＵＦＪモルガン・スタンレー証券 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      三菱UFJ eスマート証券（旧auカブコム証券） /
                    </li>
                    <li className="inline-block mb-2 px-0.5">松井証券 /</li>
                    <li className="inline-block mb-2 px-0.5">荘銀投信 /</li>
                    <li className="inline-block mb-2 px-0.5">ダイレクト /</li>
                    <li className="inline-block mb-2 px-0.5">
                      損保ジャパンＤＣ証券確定拠出年金 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">大和証券 /</li>
                    <li className="inline-block mb-2 px-0.5">
                      日本インベスター・ソリューション・アンド・テクノロジー確定拠出年金（JIS&T）
                      /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      日本レコード・キーピング・ネットワーク確定拠出年金 /
                    </li>
                    <li className="inline-block mb-2 px-0.5">
                      北都投信ダイレクト /
                    </li>
                    <li className="inline-block mb-2 px-0.5">野村證券</li>
                  </ul>
                  <p className="text-sm mb-2">
                    その他、銀行口座残高・電子マネーなどの資産も連携しております。
                  </p>
                </div>
                {/*推奨環境*/}
                <div className=" ">
                  <h3 id="env" className="text-lg font-bold mb-2 text-center">
                    推奨環境
                  </h3>
                  <p className="mb-4 lg:text-center">
                    本サービスはスマートフォン向けサービスです。
                    <br />
                    以下の環境以外では正常に動作しない可能性がございます。
                  </p>
                  <div className="flex justify-center space-x-4">
                    <div className="text-left">
                      <div className="font-bold text-lg">iOS</div>
                      <ul className="pl-4 list-disc">
                        <li>Safari 最新版</li>
                        <li>Chrome 最新版</li>
                      </ul>
                    </div>
                    <div className="text-left">
                      <div className="font-bold text-lg">Android</div>
                      <ul className="pl-4 list-disc">
                        <li>Chrome 最新版</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>

            {/*セキュリティについて*/}
            <section className="bg-neutral-150 pt-16 pb-16 js-ui-animation-fadeup">
              <div className="px-2 bg-white">
                <div className="text-center mb-8">
                  <h2
                    id="security"
                    className="lg:text-3xl text-xl font-bold pt-8">
                    セキュリティについて
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                </div>

                <div className="p-4 lg:flex items-center ">
                  <div className="lg:w-1/4 text-center">
                    <img
                      loading="lazy"
                      src="/static/images/lp/privacy.png"
                      alt="個人情報保護への取組み"
                      width="200"
                      height="100"
                      className="mx-auto"
                    />
                  </div>
                  <div className="lg:w-3/4">
                    <h3
                      id="security_info"
                      className="font-bold text-blue text-2xl mb-4">
                      個人情報保護への取組み
                    </h3>
                    <p className="mb-8 leading-relax">
                      株式会社ミンカブ・ジ・インフォノイドは、事業を展開していくうえで、個人情報の保護が重大なテーマであると認識し、
                      個人情報を適切に管理することを社会的責務であると考えております。
                      個人情報保護に関する基本方針を以下のとおり定め、役員、従業員および関係者に周知徹底を図り、個人情報の保護に努めてまいります。
                      <br />
                      <a
                        href="https://minkabu.co.jp/privacy_policy"
                        target="_blank"
                        rel="noopener"
                        className="text-link mt-2">
                        プライバシーポリシー
                        <i className="icon-external-link ml-2"></i>
                      </a>
                    </p>
                  </div>
                </div>

                <div className="p-4 lg:flex items-center ">
                  <div className="lg:w-1/4 text-center">
                    <img
                      loading="lazy"
                      src="/static/images/lp/password.png"
                      alt="パスワード不要"
                      width="200"
                      height="100"
                      className="mx-auto"
                    />
                  </div>
                  <div className="lg:w-3/4">
                    <h3
                      id="security_password"
                      className="font-bold text-blue text-2xl mb-4">
                      パスワード情報について
                    </h3>
                    <p className="mb-8 leading-relax">
                      証券口座の連携のためにみんかぶアセットプランナー上でご入力いただく情報は証券会社の「ログインID」と「パスワード」です。
                      <br />
                      証券取引に関わるパスワードをお聞きすることはありません。
                    </p>
                  </div>
                </div>
              </div>
            </section>

            {/* よくある質問/参考情報 */}
            <section className="bg-white pt-16 pb-16 js-ui-animation-fadeup">
              <div className="container w-full px-2">
                <div className="text-center lg:mb-8">
                  <h2
                    id="faq"
                    className="lg:text-3xl text-xl font-bold mb-2 leading-6">
                    よくある質問/参考情報
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                </div>

                <div className="lg:px-4 px-2 py-4 leading-relax">
                  <dl>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナー（アセプラ）とは何ですか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナーとは、株式や投資信託を管理、分析する投資管理アプリです。複数の証券口座や銀行口座にある資産をまとめて管理できます。取引履歴や損益、資産推移などをチャートやグラフで確認できます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナー（アセプラ）でどんなことができますか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナーでは以下の機能を提供しています。
                          <div className="mt-2 font-bold">
                            （1）資産管理チャート機能
                          </div>
                          <div>
                            複数の証券口座で保有する株式、投資信託などの資産をまとめて管理できます。損益、資産推移をチャートで確認できるほか、商品ごと、口座ごとにポートフォリオを見ることができます。複数口座の資産状況が一目でわかります。
                          </div>
                          <div className="mt-2 font-bold">
                            （2）資産のグルーピング機能
                          </div>
                          <div>
                            連携した証券口座や銀行口座などを「教育資金」「老後資金」など目的別、「NISA」「積立投資」など運用別にグループを分けて管理することができます。
                          </div>
                          <div className="mt-2 font-bold">
                            （3）取引履歴機能
                          </div>
                          <div>
                            株価チャート上に、株式や投資信託などの売買履歴を記録し、取引タイミングを振り返ることができます。過去の取引履歴から投資の傾向をつかみ、次回の取引に役立てることができます。
                          </div>
                          <div className="mt-2 font-bold">
                            （4）配当金管理機能
                          </div>
                          <div>
                            複数口座の配当金の入金額や予想配当金を銘柄ごとにまとめて管理できます。年間配当金、月別配当金がグラフで見れるほか、過去の入金実績も自動で集計します。税引き表示にも対応しています。利用者の声などは
                            <a
                              href="https://tw.minkabu.jp/postNotificationList/1768974239613"
                              className="text-link underline"
                              target="_blank"
                              rel="noopener">
                              「配当金を管理したい」にお答えします
                            </a>
                            をご参照ください。
                          </div>
                          <div className="mt-2 font-bold">
                            （5）資産目標サポート機能
                          </div>
                          <div>
                            「老後資金1,000万円」など資産運用の目的と目標金額を設定し、毎月の積立額や運用期間から目標達成までをシミュレーションできま
                            す。資産目標サポートでは、以下をご確認いただけます。
                            <br />
                            ・目標達成に必要な運用利回り
                            <br />
                            ・リスクを抑えた投資商品（投資信託・ETF）の提案
                            <br />
                            ・ポートフォリオ分析
                          </div>
                          <div className="mt-2 font-bold">
                            （6）資産レポート機能
                          </div>
                          <div>
                            保有資産の損益や資産変動などを日ごと、週ごと、月ごとにまとめて資産レポートを作成します。
                            <br />
                            資産レポートをLINEに送ることもできます。
                          </div>
                          <div className="mt-2 font-bold">
                            （7）ペルソナチャート機能
                          </div>
                          <div>
                            みんかぶアセットプランナーを利用しているユーザーの資産データを「年代」「年収」「投資歴」「投資先（株式、NISAなど）」「資産総額」などで絞り込み、自分の資産と比較できます。ペルソナチャート機能は、みんかぶ会員に登録すると無料でご利用いただけます。
                          </div>
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          連携できる証券会社はどこですか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          SBI証券、楽天証券をご連携いただけます。その他の証券会社は連携準備中となります（2025年8月時点）。
                          <br />
                          口座連携準備中の証券会社は、Moneytreeと連携することで一部の資産を管理できます。詳細は
                          <a
                            href="/#accountinfo"
                            className="text-link underline">
                            コチラ
                          </a>
                          をご確認ください。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          連携できる金融商品はなんですか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          以下の金融商品を連携することができます。
                          <br />
                          ・国内株式（現物、信用）
                          <br />
                          ・外国株式（現物）
                          <br />
                          ・投資信託
                          <br />
                          ・ETF・ETN（国内、外国）
                          <br />
                          ・REIT（国内、外国）
                          <br />
                          ・債券（国内、外国）
                          <br />
                          ・EB（国内、外国）
                          <br />
                          ・ロボアドバイザー
                          <br />
                          ・現金
                          <br />
                          連携できない資産（不動産、ゴールドなど）は、手入力で資産を追加し管理することができます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        銀行口座も連携できますか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          みんかぶアセットプランナーでは家計簿アプリ「マネーツリー」と連携し、銀行口座の「残高」や「取引/入出金履歴」を管理することができます。※
                          Moneytree IDと連携する必要があります。
                          <br />
                          詳しくは
                          <a
                            href="https://tw.minkabu.jp/postNotificationList/1768975113786"
                            className="text-link underline"
                            target="_blank"
                            rel="noopener">
                            「銀行口座を連携したい」にお答えします
                          </a>
                          をご参照下さい。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="flex flex-row items-baseline font-bold">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        おすすめの国内株式を提案する機能はありますか？
                      </dt>
                      <dd className="flex flex-row items-baseline">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span>
                          みんかぶアセットプランナーには国内株式を提案する機能はありません。みんかぶの「株式ランキング」や「銘柄スクリーニング」などで銘柄を探すことができます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          みんかぶアセットプランナーの利用料金を教えてください
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          SBI証券の口座をお持ちの方は一部の機能（複数口座連携、配当金管理、資産目標サポート、週次・月次レポートなど）を除き無料でご利用いただけます。
                          アセプラのすべての機能のご利用には「みんかぶプレミアム（税込1,320円/月）」にご登録が必要です。
                          <br />
                          初回登録のみ30日間無料でご利用いただけます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          複数の証券口座を簡単に管理するコツはありますか？
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          複数の証券口座をまとめて管理できる投資管理アプリを使うのがおすすめです。
                          <br />
                          各証券口座の資産情報を自動で更新し、株式、投資信託などの資産をグラフやチャートで表示したり、確定損益を簡単に管理することができます。
                        </span>
                      </dd>
                    </div>
                    <div className="border-b border-gray-500 py-4">
                      <dt className="font-bold flex items-start">
                        <span className="text-orange font-bold mr-2 text-xl">
                          Q.
                        </span>
                        <span className="pt-1">
                          投資管理アプリの選び方を教えてください
                        </span>
                      </dt>
                      <dd className="flex items-start">
                        <span className="text-blue font-bold mr-2 text-xl">
                          A.
                        </span>
                        <span className="pt-1">
                          投資の管理には以下が役立ちます。ご自身に必要な機能が充実しているかで選ぶのがおすすめです。
                          <br />
                          ・対応している証券口座/金融商品
                          <br />
                          ・セキュリティ
                          <br />
                          ・損益（収支）を管理できるか
                          <br />
                          ・取引履歴を分析できるか
                          <br />
                          ・ポートフォリオを管理できるか　　　など
                        </span>
                      </dd>
                    </div>
                  </dl>
                </div>
              </div>
            </section>

            {/* アセプラの利用方法 */}
            <section className="flex items-center flex-col py-8 lg:py-12">
              <h2 className="text-2xl font-bold text-center leading-8 mb-8 lg:mb-4 lg:text-2xl">
                アセプラの利用方法
              </h2>
              <ul className="lg:flex justify-center lg:text-2xl lg:leading-8 lg:mb-12 w-full px-1 lg:px-12">
                <li className="border border-solid flex flex-col items-center rounded-lg px-4 py-8 mb-4 bg-white lg:max-w-panel-m lg:mb-0">
                  <div className="text-2xl text-center font-bold mb-2 text-orange-asset">
                    STEP１
                  </div>
                  <div className="text-center font-bold text-base leading-7">
                    みんかぶ会員登録
                  </div>
                  <img
                    src="/static/images/lp/asset_step1.png"
                    alt="みんかぶ会員登録"
                    width="300"
                    height="240"
                    className="m-4"
                  />
                  <div className="px-3.5 max-w-btn-m h-7 rounded-btn-m mb-4 flex items-center justify-center bg-orange-100">
                    <img
                      src="/static/images/lp/clock_img.svg"
                      alt="clock"
                      width="18"
                      height="18"
                      className="w-4.5 h-4.5"
                    />
                    <div className="text-center font-bold text-sm w-20 text-white leading-7">
                      約３分
                    </div>
                  </div>
                  <div className="text-base mb-4 text-left leading-6">
                    <div className="">
                      「みんかぶ会員登録」で登録手続きを行なってください。
                    </div>
                    <div className="opacity-75">
                      ※すでにみんかぶ会員の方はこの手続きは必要ありません
                    </div>
                  </div>
                  <div className="text-base text-link leading-6 flex justify-center items-center cursor-pointer">
                    みんかぶ会員登録はこちら
                  </div>
                </li>
                <li className="border border-solid flex flex-col items-center rounded-lg px-4 py-8 mb-4 bg-white lg:max-w-panel-m lg:mb-0 lg:ml-8">
                  <div className="text-2xl text-center font-bold mb-2 text-orange-asset">
                    STEP2
                  </div>
                  <div className="text-center font-bold text-base leading-7">
                    お手持ちの口座と連携
                  </div>
                  <img
                    src="/static/images/lp/asset_step2.png"
                    alt="証券口座を登録"
                    width="300"
                    height="240"
                    className="m-4"
                  />
                  <div className="px-3.5 max-w-btn-m h-7 rounded-btn-m mb-4 flex items-center justify-center bg-orange-100">
                    <img
                      src="/static/images/lp/clock_img.svg"
                      alt="clock"
                      width="18"
                      height="18"
                      className="w-4.5 h-4.5"
                    />
                    <div className="text-center font-bold text-sm w-20 text-white leading-7">
                      最短１分
                    </div>
                  </div>
                  <div className="text-base mb-4 text-left leading-6">
                    <div className="">
                      お手持ちの口座のID（ユーザーネーム・口座番号）・パスワードを入力するだけでアセプラと連携できます。
                    </div>
                  </div>
                </li>
                <li className="border border-solid flex flex-col items-center rounded-lg px-4 py-8 mb-4 bg-white lg:max-w-panel-m lg:mb-0 lg:ml-8">
                  <div className="text-2xl text-center font-bold mb-2 text-orange-asset">
                    STEP3
                  </div>
                  <div className="text-center font-bold text-base leading-7">
                    連携した口座の資産がまとめて見れる
                  </div>
                  <img
                    src="/static/images/lp/asset_step3.png"
                    alt="連携した証券口座をチャートで確認できる"
                    width="300"
                    height="240"
                    className="m-4"
                  />
                  <div className="px-3.5 max-w-btn-m h-7 rounded-btn-m mb-4 flex items-center justify-center bg-orange-100">
                    <img
                      src="/static/images/lp/clock_img.svg"
                      alt="clock"
                      width="18"
                      height="18"
                      className="w-4.5 h-4.5"
                    />
                    <div className="text-center font-bold text-sm w-20 text-white leading-7">
                      ５分〜10分
                    </div>
                  </div>
                  <div className="text-base mb-4 text-left leading-6">
                    <div className="">
                      連携口座一覧に連携した口座が追加されていたら完了です。連携した口座の内容がチャートなどに反映されます。
                    </div>
                    <div className="opacity-75">
                      ※データの反映まで時間がかかる場合があります。
                    </div>
                  </div>
                </li>
              </ul>
              <div className="lg:mt-8 mt-4 text-bluegray-700 text-base text-center lg:mx-0 mx-4">
                ご利用には「みんかぶプレミアム会員」の登録が必要です。
              </div>
              {/* PC */}
              <div
                className={`hidden bg-gradient-to-r bg-gradient-r-red lg:flex flex-col text-center text-xl w-full max-w-btn-l py-4 text-white leading-9 rounded-lg my-4 pt-4 pb-2 cursor-pointer hover:opacity-75 cv_premium`}>
                <a href={linkRegist()}>
                  <div className="text-2xl font-bold">アセプラを使ってみる</div>
                  <div className="flex justify-center mb-auto app-primary-label-block text-lg">
                    <div className="inline-flex items-center flex-col">
                      初回30日間無料
                    </div>
                  </div>
                </a>
              </div>
              {/* SP */}
              <div className="w-full px-8">
                <div
                  className={`lg:hidden bg-gradient-to-r bg-gradient-r-red flex flex-col text-center text-sm w-full max-w-btn-l py-2 mx-auto text-white rounded-lg mt-4 mb-8 cursor-pointer hover:opacity-75 cv_premium`}>
                  <a href={linkRegist()}>
                    <div className="text-lg font-bold">
                      アセプラを使ってみる
                    </div>
                    <div className="flex justify-center mb-auto app-primary-label-block text-sm">
                      <div className="inline-flex justify-center flex-col">
                        初回30日間無料
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </section>

            {/* 運営元・関連情報 */}
            <section className="flex pt-16 pb-16 bg-bluegray-50">
              <div className="container px-2">
                <div className="text-center mb-8">
                  <h2
                    id="asepla_information"
                    className="lg:text-3xl text-xl font-bold mb-2 leading-6">
                    運営元・関連情報
                  </h2>
                  <div className="h-4 w-64 bg-red-500 right-half mx-auto mt-2"></div>
                </div>
                <table className="text-center w-full lg:w-1/2 lg:mx-auto">
                  <tbody>
                    <tr className="border-b border-gray-400 py-4">
                      <th className="px-2 py-4 font-bold bg-gray-300 w-1/4">
                        名称
                      </th>
                      <td className="px-2 py-4 bg-white w-3/4">
                        MINKABU ASSET PLANNER
                        <br />
                        （みんかぶアセットプランナー）
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        提供元
                      </td>
                      <td className="px-2 py-4 bg-white">
                        株式会社ミンカブ・ジ・インフォノイド
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        料金プラン
                      </td>
                      <td className="px-2 py-4 bg-white">
                        <p className="fonnt-bold">
                          月額1,320 円（税込）　※初回30日間無料
                        </p>
                        アセプラのご利用は基本有料となっております。
                        <br />
                        SBI証券口座連携のみ一部機能を無料でご利用いただけます。
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        利用環境
                      </td>
                      <td className="px-2 py-4 bg-white">
                        【Android】OS 9.0以上
                        <br />
                        【iPhone】iOS 13.0以上
                      </td>
                    </tr>
                    <tr className="border-b border-gray-400 py-4">
                      <td className="px-2 py-4 font-bold bg-gray-300">
                        注意事項
                      </td>
                      <td className="px-2 py-4 bg-white text-sm text-left">
                        ・MINKABU ASSET PLANNERは株式会社MONO
                        Investmentが提供するデータ収集システムおよび、マネーツリー株式会社が提供するMoneytree
                        LINK
                        APIを利用し、各証券会社や金融機関のWebサイトから情報を取得します。
                        <br />
                        ・SBI証券の「PC登録あんしんサービス」をご利用の口座はサービスをご利用いただけません。
                        証券会社Webサイトにて、ユーザーネームを変更された場合は、変更後の口座を新たに登録する必要があります。
                        変更後の口座は変更前の口座とは別の口座として扱われ、データは引き継がれません。
                        <br />
                        例 )<br />
                        資産推移画面で推移グラフが連続しない
                        <br />
                        取引詳細の「理由」欄が引き継がれない
                        <br />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </section>
            {/* PC */}
            <div className="lg:flex hidden">
              <a
                href={linkRegist()}
                className="block fixed z-40 cv_premium"
                style={{ right: '10px', bottom: '10px' }}>
                <img alt="" src="/static/images/lp/pc_cv_btn.svg" />
              </a>
            </div>
            {/* SP */}
            <div className="flex lg:hidden">
              <a
                href={linkRegist()}
                className="block fixed w-full z-40 bg-white cv_premium"
                style={{ right: '0rem', bottom: '0rem' }}>
                <div className="bg-gradient-to-r bg-gradient-r-red flex flex-row items-center justify-center text-center max-w-full py-3 m-1 rounded-lg cursor-pointer hover:opacity-75 cv_premium">
                  <div className="text-xl text-white font-bold">
                    いますぐ30日間無料体験を試す
                  </div>
                  <img
                    alt=""
                    src="/static/images/lp/icon_arrow_right.svg"
                    style={{ width: '19px', height: '19px' }}
                  />
                </div>
              </a>
            </div>
          </>
        )}

        <div id="footer" className="bg-gray-800 py-4 px-2 text-white text-sm">
          <div className="container">
            <ul className="text-center mb-8">
              <li className="inline-block mr-4">
                <a href="https://minkabu.co.jp/" target="_blank" rel="noopener">
                  運営会社
                </a>
              </li>
              <li className="inline-block mr-4">
                <a
                  href="https://info.minkabu.jp/tw_terms/"
                  target="_blank"
                  rel="noopener">
                  利用規約
                </a>
              </li>
              <li className="inline-block mr-4">
                <a
                  href="https://minkabu.co.jp/privacy_policy"
                  target="_blank"
                  rel="noopener">
                  プライバシーポリシー
                </a>
              </li>
              {!isIosApp() && (
                <>
                  <li className="inline-block mr-4">
                    <a
                      href="https://info.minkabu.jp/economy/"
                      target="_blank"
                      rel="noopener">
                      特定商取引表示
                    </a>
                  </li>
                  <li className="inline-block mr-4">
                    <a
                      href="https://info.minkabu.jp/law/"
                      target="_blank"
                      rel="noopener">
                      ご利用上の注意（関連法規）
                    </a>
                  </li>
                  <li className="inline-block mr-4">
                    <a
                      href="https://info.minkabu.jp/ad/"
                      target="_blank"
                      rel="noopener">
                      広告掲載・取扱商品
                    </a>
                  </li>
                  <li className="inline-block mr-4">
                    <a
                      href="https://support.minkabu.jp/hc/ja"
                      target="_blank"
                      rel="noopener">
                      ヘルプ/FAQ
                    </a>
                  </li>
                </>
              )}
            </ul>
            <div className="copyright mb-4">
              <a
                href="https://minkabu.co.jp/"
                className="text-center"
                title="株式会社ミンカブ・ジ・インフォノイドコーポレートサイトへ"
                target="_blank"
                rel="noopener">
                <img
                  loading="lazy"
                  src="/static/images/lp/min_infonoid_logo_white.svg"
                  width="150"
                  height="25"
                  className="mx-auto"
                  alt="ミンカブ・ジ・インフォノイド ロゴ"
                />
              </a>
              <div className="text-center">
                <span className="dptblc tar vabt">
                  (C) MINKABU THE INFONOID, Inc.
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
/* eslint-enable react/jsx-no-target-blank */

export default InvestorBenefitsLP;
